// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for ZH
 * @file translations.zh.js
 * @description Main application translations for zh
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsZh = {
                'login.title': '登录',
                'login.slogan': '无界对话！',
                'login.username': '用户名',
                'login.password': '密码',
                'login.submit': '登录',
                'login.loading': '加载中...',
                'login.autoRegister.title': '自动注册',
                'login.autoRegister.description': '如果您没有账户，请输入您的用户名和密码。将自动创建。',
                'login.forgotPassword': '忘记密码？',
                'login.passwordRecovery.title': '恢复密码',
                'login.passwordRecovery.description': '输入您的电子邮件以接收恢复链接。',
                'login.passwordRecovery.emailLabel': '电子邮件',
                'login.passwordRecovery.emailPlaceholder': '输入您的电子邮件',
                'login.passwordRecovery.emailHelp': '恢复链接将发送到您的电子邮件',
                'login.passwordRecovery.send': '发送',
                'login.passwordRecovery.success': '恢复链接已发送到您的电子邮件。请检查您的收件箱。',
                'login.passwordRecovery.successTitle': '邮件已发送',
                'login.passwordRecovery.successMessage': '我们已向您发送了包含重置密码说明的邮件。\n请检查收件箱和垃圾邮件文件夹。链接可能需要几分钟才能到达。',
                'login.passwordRecovery.devExplanation': '在开发模式下，邮件不会发送到您的收件箱；会保存以供预览。请使用「查看邮件」查看内容和恢复链接。',
                'login.passwordRecovery.devSinkNotice': '⚠️ 开发模式：此邮件未发送到您的收件箱。请使用「查看邮件」打开生成的消息和链接。',
                'login.passwordRecovery.invalidEmail': '请输入有效的电子邮件地址',
                'login.error.invalidPassword': '密码无效',
                'common.language': '语言',
                'common.loading': '加载中…',
                'common.back': '返回',
                'common.backToStart': '返回首页',
                'common.changeUser': '更换用户',
                'common.request_id_label': '请求ID',
                'login.email.invalid': '请输入有效的电子邮件',
                'captcha.solve': '请正确完成验证码',
                'captcha.generateError': '生成验证码时出错。请刷新页面。',
                'auth.require_email': '完成注册需要电子邮件。请输入您的电子邮件。',
                'auth.invalid_credentials': '用户名或密码错误。',
                'auth.account_blocked': '账户未激活。请输入您的电子邮件以激活。',
                'auth.device_limit_reached': '已达到设备限制。请在另一台设备上退出登录或升级您的计划。',
                'auth.login.device_limit.title': '已达到会话或设备上限',
                'auth.login.device_limit.body': '您的套餐对同时活跃的会话或设备数量有限制。要登录，请在其他设备上退出登录或关闭其他活跃会话，然后重试。',
                'auth.password_incorrect': '密码不正确。',
                'auth.login.password_error_title': '密码错误',
                'auth.login.password_attempts_hint': '您有3次机会正确输入密码。如果超过此次数，您需要重置密码。',
                'auth.login.password_attempts_exhausted_title': '已达到尝试次数上限',
                'auth.login.password_attempts_exhausted_body': '您已超过允许的3次尝试。要继续，请通过「忘记密码？」重置密码。',
                'auth.login.go_to_reset_password': '前往重置密码',
                'auth.login.password_remaining_two': '您还剩 2 次机会。',
                'auth.login.password_remaining_one': '您还剩 1 次机会。',
                'auth.login.password_attempts_locked_inline': '已达到最大尝试次数。您必须重置密码。',
                'auth.account_inactive_email_mismatch': '账户未激活且电子邮件不匹配。',
                'auth.captcha_failed': '验证码错误。请检查您的答案。',
                'auth.captcha_expired': '验证已过期。已自动生成新的验证。',
                'auth.unauthorized': '您没有访问权限。',
                'auth.generic_error': '发生错误。请重试。',
                'auth.method_not_allowed': '不允许使用此方法。',
                'auth.invalid_data': '数据无效。',
                'auth.credentials_required': '需要用户名和密码。',
                'auth.csrf_invalid': '会话无效。请刷新页面后重试。',
                'auth.username_taken': '该用户名已被注册。请登录或选择其他。',
                'auth.username_unavailable': '该用户名不可用。',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': '密码至少需要6个字符。',
                'auth.rate_limit': '尝试次数过多。请稍后再试。',
                'auth.confirm_success': '账户已成功确认。正在跳转到登录...',
                'auth.confirm_already_active': '您的账户已激活。您可以登录。',
                'auth.reset_sent': '如果该电子邮件已注册，您将收到重置密码的说明。',
                'auth.reset_token_invalid': '链接无效或缺失。',
                'auth.reset_token_expired': '此链接已过期。请在“忘记密码？”中申请新链接。',
                'auth.reset_done': '密码已更新。您现在可以登录。',
                'auth.reset_fatal': '保存时出错。请稍后重试。',
                'auth.password_mismatch': '两次输入的密码不一致。',
                'resetPassword.page.title': '新密码',
                'resetPassword.page.description': '输入您的新密码（至少6个字符）。',
                'resetPassword.newPassword': '新密码',
                'resetPassword.newPasswordPlaceholder': '至少6个字符',
                'resetPassword.submit': '重置密码',
                'resetPassword.success': '密码已更新。正在跳转到登录...',
                'resetPassword.backToLogin': '返回登录',

                'account.delete.section_title': '删除账户',
                'account.delete.description': '删除账户将永久移除您的所有数据、消息、联系人和设置。此操作无法撤销。',
                'account.delete.button': '删除我的账户',
                'accountDeletion.title': '账户与数据删除',
                'accountDeletion.description': '请申请删除您的 ArChat 账户及相关数据。',
                'accountDeletion.openRequest': '申请删除账户和数据',
                'account.delete.confirm_title': '删除账户',
                'account.delete.confirm_message': '确定要删除账户吗？将向您的收件箱发送确认邮件。删除是永久且不可恢复的。',
                'account.delete.email_sent_title': '邮件已发送',
                'account.delete.email_sent': '我们已向您发送确认邮件。请查收收件箱并点击链接确认删除。',
                'account.delete.error': '无法处理请求。请重试。',
                'account.delete.confirm_page_title': '确认删除账户',
                'account.delete.confirm_page_desc': '您即将永久删除 ArChat 账户。所有数据、消息、联系人和设置都将被移除。此操作无法撤销。',
                'account.delete.confirm_final_button': '是的，永久删除我的账户',
                'account.delete.cancel_go_back': '取消并返回',
                'account.delete.done_title': '账户已删除',
                'account.delete.done_message': '您的账户已成功删除。所有数据均已移除。',
                'account.delete_token_expired': '删除链接已过期或无效。请从个人资料申请新的链接。',
                'account.delete_token_invalid': '删除链接无效或缺失。',
                'account.delete_email_failed': '无法发送确认邮件。请稍后重试。',
                'account.delete_error': '处理删除时出错。请稍后重试。',

                'auth.register_success_email_sent': '账户已创建。已发送确认电子邮件。请查收收件箱（及垃圾邮件文件夹）并点击链接激活账户。',
                'auth.register_success_email_pending': '账户已创建，但发送确认邮件时出错。激活令牌仍然有效。请联系管理员或请求重新发送确认邮件。',
                'auth.email_not_verified': '您需要确认邮箱以激活账户。',
                'auth.email_not_verified_title': '账户待确认',
                'auth.email_send_failed': '无法发送邮件。请重试或更换邮箱。',
                'auth.email_send_failed_title': '无法发送邮件',
                'auth.register.email_failed.title': '账户已创建',
                'auth.register.email_failed.message': '您的账户已成功创建，但发送确认邮件时出现问题。请检查垃圾邮件或请求重新发送确认邮件。',
                'auth.register.success.title': '账户已创建',
                'auth.register.success.message': '您的账户已成功创建。已发送确认电子邮件。请查收收件箱（及垃圾邮件文件夹）并点击链接激活账户。',
                'auth.resend_sent': '确认邮件已重新发送。',
                'auth.resend_email': '重新发送邮件',
                'auth.retry_resend': '重试',
                'auth.change_email': '更换邮箱',
                'auth.ver_email': '查看邮件',
                'auth.already_verified': '账户已通过验证。',
                'auth.confirm_email_title': '确认邮箱',
                'auth.confirm_email_text': '激活链接将发送至：',
                'auth.confirm_email_edit': '编辑',
                'auth.confirm_email_confirm': '确认',
                'auth.confirm_email_typo_hint': '您是否指的是 ***@{suggestion}？',
                'brand.slogan': '无论语言如何，都能被理解的力量',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': '无论语言如何，都能被理解的力量',
                'home.tagline': '带自动翻译的消息平台',
                'home.login': '登录',
                'home.register': '创建账户',
                'home.language': '语言',
                'terms.title': '条款和条件',
                'terms.accept': '接受并继续',
                'terms.reject': '拒绝',
                'terms.rejectShort': '不接受',
                'terms.readAndAccept': '我已阅读并接受条款和条件',
                'terms.cancel': '取消',
                'register.pageTitle': '创建账户',
                'register.pageSubtitle': '填写信息以创建账户。',
                'register.submitLabel': '创建账户',
                'register.confirm_title': '确认账户',
                'register.confirm_message': '您即将创建账户：',
                'register.confirm': '确认',
                'register.login_link': '已有账户？',
                'register.password_hint': '至少6个字符',
                'register.checking': '验证中…',
                'register.username_taken': '该用户名已被使用。',
                'register.available': '可用',
                'register.emailAlreadyExists': '该邮箱已被注册。',
                'register.continue': '继续',
                'login.demo.title': '演示访问',
                'login.demo.credentials': '用户: demo / 密码: demo',
                'captcha.label': '安全验证',
                'security.verification_title': '安全验证',
                'security.captcha_question': '验证问题',
                'security.enter_answer': '输入答案',
                'captcha.description': '解决数学运算以验证您是人类',
                'captcha.required': '请输入验证码答案以继续。',
                'menu.conversations': '对话',
                'menu.contacts': '联系人',
                'menu.dashboard': '仪表板',
                'menu.profile': '我的资料',
                'menu.settings': '设置',
                'menu.help': '帮助',
                'menu.logout': '退出',
                'menu.files': '我的文件',
                'reviews.menu_title': '评价',
                'reviews.rate_archat': '评价 ArChat',
                'reviews.my_review': '我的评价',
                'navbar.contacts': '联系人',
                'navbar.profile': '我的资料',
                'navbar.settings': '设置',
                'navbar.logout': '退出',
                'onboarding.welcome_title': '欢迎使用 ArChat®',
                'onboarding.welcome_subtitle': '与任何人、以任何语言进行沟通。',
                'onboarding.step1': '步骤 1',
                'onboarding.step1_title': '步骤 1',
                'onboarding.step1_description': '邀请您的第一个联系人',
                'onboarding.step2': '步骤 2',
                'onboarding.step2_title': '步骤 2',
                'onboarding.step2_description': '发送您的第一条消息',
                'onboarding.invite_contact': '邀请联系人',
                'onboarding.explore_archat': '探索 ArChat®',
                'contacts.invite_contact': '邀请联系人',
                'contacts.no_contacts': '没有联系人',
                'help.view_initial_guide': '查看初始指南',
                'suggestions.title': '建议',
                'suggestions.form.title': '建议标题',
                'suggestions.form.message': '描述您的想法',
                'suggestions.form.submit': '发送建议',
                'suggestions.send': '发送建议',
                'suggestions.captcha_placeholder': '结果',
                'suggestions.cooldown': '在发送另一个建议之前，您必须等待 {minutes} 分钟。',
                'suggestions.success_title': '建议已发送',
                'suggestions.success_message': '您的建议已成功发送。跟踪编号：{id}',
                'suggestions.success': '感谢您的建议。我们的团队会进行审核。',
                'suggestions.success.title': '感谢您的建议！',
                'suggestions.success.reference': '参考编号',
                'suggestions.success.review': '我们的团队将审核您的想法。',
                'suggestions.success.email': '我们已向您发送确认邮件。',
                'suggestions.success.copy': '复制',
                'suggestions.success.copied': '参考编号已复制',
                'suggestions.form.required': '标题和内容为必填项。',
                'suggestions.error': '发送失败，请重试。',
                'profile.title': '我的资料',
                'profile.founderBadge': '创始人 #{position}/{limit}',
                'profile.founderTooltip': '创始成员 – 只要订阅保持有效，终身冻结价格',
                'profile.founderMember': '创始成员',
                'profile.founderHeaderBadge': '★ 创始会员 #{position}/150',
                'profile.camera.access_denied': '无法访问摄像头，请检查权限。',
                'profile.edit': '编辑',
                'profile.save': '保存更改',
                'profile.save.success': '您的个人资料已成功更新。',
                'profile.save.success.title': '个人资料已更新',
                'profile.update.success.title': '个人资料已更新',
                'profile.update.success.message': '您的更改已保存。',
                'profile.save.error': '无法更新个人资料。请重试。',
                'profile.save.error.title': '保存错误',
                'profile.cancel': '取消',
                'profile.nick': '用户名',
                'profile.nick.help': '您在系统中的唯一标识符',
                'profile.name': '名字',
                'profile.lastname': '姓氏',
                'profile.alias': '别名',
                'profile.email': '电子邮件',
                'profile.phone': '电话',
                'profile.language': '语言',
                'profile.country': '国家',
                "profile.country.select": "选择国家",
                'profile.biography': '传记',
                'bio.modal.original': '原文',
                'bio.modal.translation': '译文',
                'bio.modal.empty': '此联系人没有简介。',
                'bio.modal.translating': '正在翻译…',
                'bio.modal.translation_error': '无法翻译简介。',
                'attachment.unnamed_file': '文件',
                'auth.login_error.default_title': '访问错误',
                'auth.login_error.default_message': '无法登录。',
                'profile.photo': '个人资料照片',
                'notifications.bell.aria': '通知',
                'notifications.panel.title': '通知',
                'notifications.empty': '暂无通知',
                'notifications.mark_read': '打开时标记为已读',
                'billing.change_plan': '更换方案',
                'billing.usage.title': '计划使用情况',
                'billing.usage.users': '用户',
                'billing.usage.messages': '消息（今日）',
                'billing.usage.invitations': '邀请（今日）',
                'billing.usage.messages_month': '本月消息',
                'billing.usage.chats': '对话',
                'billing.usage.warning': '您即将达到计划限制。升级到 PRO 以获得更多容量。',
                "plans.limit.reached": "达到限制 - 改进计划",
                'profile.theme.dark': '深色模式',
                'profile.theme.light': '浅色模式',
                'profile.theme.argentina': '阿根廷主题',
                'modal.title': '标题',
                'modal.success.title': '成功',
                'modal.error.title': '错误',
                'modal.warning.title': '警告',
                'info.title': '信息',
                'appearance.title': '外观',
                'appearance.theme.light': '浅色',
                'appearance.theme.dark': '深色',
                'theme.title': '主题',
                'theme.light': '浅色',
                'theme.dark': '深色',
                'profile.photo.section': '个人照片',
                'profile.personalInfo': '个人信息',
                'profile.preferences': '偏好设置',
                'profile.country.help': '时区将根据所选国家自动分配',
                'profile.lastname.placeholder': '您的姓氏（可选）',
                'profile.name.placeholder': '您的名字（可选）',
                'profile.biography.placeholder': '告诉我们关于您...',
                'profile.notifications.sound': '通知声音',
                'profile.notifications.sound_desc': '收到消息或重要提醒时播放声音',
                'profile.plan.title': '订阅计划',
                'profile.plan.current': '您当前的计划',
                'profile.plan.expires': '到期日期',
                'profile.plan.free.description': '免费计划功能有限。升级到 PRO 以享受所有功能，无任何限制。',
                'profile.plan.pro.description': '太好了！您可以完全访问 ArChat® 的所有高级功能。',
                "profile.plan.upgrade.button": "升级到专业版",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'profile.photo.change': '更改个人资料照片',
                'message.placeholder': '写消息...',
                'message.placeholderWithFile': '发送文件',
                "message.sent_from_country": "发送自",
                "message.sent_at_local_time": "发行人当地时间",
                "message.timezone_label": "时区",
                "message.context_info": "该消息保留发送时的时间上下文。",
                "message.context_pro_hint": "此消息具有 Pro 计划中可用的时间和地理背景。",
                "message.context_pro_badge": "上下文专业版",
                'attachment.title': '附加文件',
                'attachment.close': '关闭',
                'attachment.gallery': '照片/视频库',
                'attachment.cameraFront': '前置摄像头',
                'attachment.cameraBack': '后置摄像头',
                'attachment.cameraWeb': '网络摄像头',
                'attachment.selectFile': '选择文件（PDF、文本、图片、视频）',
                'attachment.remove': '删除',
                'attachments.recipientFreeBlocked.title': '方案限制',
                'attachments.recipientFreeBlocked.sender': '对方为 Free 方案，无法接收附件。',
                'attachments.recipientFreeBlocked.receiver': '{senderName} 尝试向你发送附件，但你的 {planName} 方案无法接收附件。建议升级到更高方案以接收文件。',
                'attachments.recipientFreeBlocked.upgradeCta': '升级方案',
                'attachment.audioNotSupported': '音频消息与ArChat®不兼容。请发送书面消息。',
                'message.audioDeprecated.title': '语音消息不兼容',
                'message.audioDeprecated.message': '此语音消息不再与ArChat®兼容。请发送书面消息。',
                'camera.title': '相机',
                'camera.close': '关闭',
                'camera.switch': '切换相机',
                'camera.capture': '拍照',
                'camera.loading': '启动相机...',
                'camera.retry': '重试',
                'camera.error.access': '无法访问相机。请检查权限。',
                'camera.error.permission': '相机权限被拒绝。请在浏览器设置中允许相机访问。',
                'camera.error.notFound': '未找到相机。',
                'camera.error.busy': '相机正被其他应用程序使用。',
                'camera.error.constraint': '无法满足相机约束条件。',
                'profile.photo.take': '拍照',
                'profile.photo.gallery': '从图库选择',
                'profile.photo.uploading': '正在上传图片...',
                'profile.photo.upload.success': '个人资料照片更新成功',
                'profile.photo.upload.success.title': '照片已更新',
                'profile.photo.upload.error': '上传个人资料照片时出错。请重试。',
                'profile.photo.upload.error.title': '上传错误',
                'user.default': '用户',
                'logout.title': '确认',
                'logout.confirm': '您确定要退出吗?',
                'contacts.title': '联系人',
                'contacts.search': '搜索联系人',
                'contacts.search.placeholder': '按用户名、姓名、姓氏、国家或语言搜索...',
                'contacts.sort': '排序',
                'contacts.sortByName': '按姓名',
                'contacts.sortByStatus': '按状态',
                'contacts.sortByRecent': '最近',
                'contacts.filter': '筛选',
                'contacts.filterAll': '全部',
                'contacts.filterAvailable': '可用',
                'contacts.filterInvited': '已邀请',
                'contacts.filterBlocked': '已屏蔽',
                'contacts.pending_invitations': '待处理邀请',
                'contacts.status.invitation_sent': '邀请已发送',
                'contacts.empty': '没有联系人',
                'contacts.empty.title': '您还没有联系人',
                'contacts.empty.message': '邀请或添加联系人以开始聊天。',
                'contacts.empty.invite_button': '邀请联系人',
                'contacts.empty.private.message': '您的个人资料是私密的。邀请联系人开始聊天。',
                'contacts.empty.private.invite_button': '邀请联系人',
                'contacts.search.no_results': '未找到联系人',
                'contacts.search.clear': '显示全部',
                'contacts.controls.search_placeholder': '搜索联系人...',
                'contacts.controls.search_label': '搜索联系人',
                'contacts.controls.sort_label': '排序方式',
                'contacts.controls.sort.name': '姓名',
                'contacts.controls.sort.status': '状态',
                'contacts.controls.sort.recent': '最近',
                'contacts.controls.sort.manual': '手动',
                'contacts.controls.sort.manual_drag_hint': '拖动以排序',
                'contacts.controls.filter_label': '状态',
                'contacts.controls.filter.all': '全部',
                'contacts.controls.filter.available': '可用',
                'contacts.controls.filter.invited': '已邀请',
                'contacts.controls.filter.blocked': '已屏蔽',
                'contacts.controls.filter.favorites': '收藏',
                'contacts.nick': '用户名',
                'contacts.name': '名字',
                'contacts.lastname': '姓氏',
                'contacts.country': '国家',
                'contacts.language': '语言',
                'contacts.status': '状态',
                'status.available': '可用',
                'status.busy': '忙碌',
                'status.in_call': '通话中',
                'status.away': '离开',
                'status.offline': '离线',
                'status.custom': '自定义消息',
                'status.set_title': '可用状态',
                'status.set_button': '更改状态',
                'status.placeholder': '可选消息（例如：会议中）',
                'contacts.status.pending_registration': '等待注册',
                'contacts.status.registered': '已邀请 - 已注册',
                'contacts.status.ready_to_chat': '可以聊天',
                'contacts.status.active_conversation': '活跃对话',
                'contacts.invitation.pending.title': '待处理邀请',
                'contacts.invitation.pending.message': '此邀请正在等待注册。联系人将收到一封电子邮件以完成注册。注册后，您可以与他们聊天。',
                'contacts.error.no_registered': '联系人尚未注册。请等待他们完成注册。',
                'contact.edit.title': '编辑联系人',
                'contact.edit.alias.label': '自定义别名',
                'contact.edit.alias.placeholder': '例如：工作上的约翰',
                'contact.edit.alias.help': '此名称将代替真实姓名显示',
                'contact.edit.nota.label': '个人备注',
                'contact.edit.nota.placeholder': '添加关于此联系人的备注...',
                'contact.edit.nota.help': '私人备注仅对您可见',
                'contact.edit.error.noUser': '错误：未识别用户',
                'contact.edit.error.noContactId': '错误：无法识别联系人',
                'contact.edit.error.save': '保存错误',
                'contact.limit.title': '已达到联系人上限',
                'contact.limit.message': 'FREE 计划每位用户最多 2 个联系人。启用计费后可升级到 FOUNDATION 或 PRO 以获得更多额度。',
                'contact.edit.info.personalized': '这些更改仅针对您个人定制，不会影响其他用户。',
                'contact.edit.profileInfo': '个人资料信息',
                'export.title': '导出对话',
                'export.description': '选择要导出此对话的格式:',
                'export.progress': '导出中...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': '包含所有图片和文件的PDF文档',
                "export.format.html": "网页",
                'export.format.html.description': '可在任何浏览器中打开的HTML文件',
                'export.info': '导出将包括此对话中的所有消息、图片和文件。',
                'export.pro_required.title': '导出对话',
                'export.pro_required.message': '此功能仅在 PRO 套餐中可用。',
                'invitation.title': '通过电子邮件邀请联系人',
                'invitation.modal.title': '发送邀请',
                'invitation.modal.description': '邀请某人在ArChat®上与您聊天。他们将收到一封包含接受邀请链接的电子邮件。',
                'invitation.email.label': '被邀请人邮箱',
                "invitation.email.placeholder": "ejemplo@email.com",
                'invitation.email.required': '邮箱是必填项',
                'invitation.email.invalid': '请输入有效的邮箱',
                'invitation.language.label': '被邀请人首选语言',
                'invitation.language.help': '电子邮件将以此语言发送',
                'invitation.mode.label': '对话模式',
                'invitation.mode.profesional': '专业',
                'invitation.mode.profesional.description': '正式和专业的对话',
                'invitation.mode.tecnico': '技术',
                'invitation.mode.tecnico.description': '技术和专业对话',
                'invitation.mode.casual': '随意',
                'invitation.mode.casual.description': '非正式和友好的对话',
                'invitation.message.label': '个人消息（可选）',
                'invitation.message.placeholder': '为被邀请人写一条个人消息...',
                'invitation.send': '发送邀请',
                'invitation.sending': '发送中...',
                'invitation.success': '邀请发送成功',
                'invitation.error': '发送邀请时出错',
                'invitation.error.self': '您不能邀请自己',
                'invitation.error.duplicate': '此邮箱已存在待处理的邀请',
                'invitation.list.title': '已发送的邀请',
                'invitation.list.empty': '您尚未发送任何邀请',
                'invitation.list.email': '邮箱',
                'invitation.list.language': '语言',
                'invitation.list.mode': '模式',
                'invitation.list.status': '状态',
                'invitation.list.created': '已发送',
                'invitation.list.expires': '过期',
                'invitation.list.actions': '操作',
                'invitation.status.pending': '待处理',
                'invitation.status.accepted': '已接受',
                'invitation.status.expired': '已过期',
                'invitation.status.cancelled': '已取消',
                'invitation.copy.link': '复制链接',
                'invitation.copy.success': '链接已复制到剪贴板',
                'invitation.cancel': '取消',
                'invitation.cancel.confirm': '您确定要取消此邀请吗？',
                'invitation.cancel.success': '邀请已成功取消',
                'invitation.cancel.title': '确认取消',
                'invitation.resend': '重新发送邮件',
                'invitation.resend.title': '重新发送邀请',
                'invitation.resend.success': '邀请邮件已成功重新发送',
                'invitation.resend.error': '重新发送邀请邮件时出错',
                'invitation.accept.title': '接受邀请',
                'invitation.accept.description': '您已被邀请在ArChat®上聊天',
                'invitation.accept.inviter': '邀请人',
                'invitation.accept.message': '个人消息',
                'invitation.accept.login': '登录',
                'invitation.accept.register': '注册',
                'invitation.accept.error.invalid': '无效的邀请令牌',
                'invitation.accept.error.expired': '此邀请已过期',
                'invitation.accept.error.accepted': '此邀请已被接受',
                'invitation.accept.error.cancelled': '此邀请已被取消',
                'invitation.accept.error.email_mismatch': '您的账户邮箱与邀请邮箱不匹配',
                'invitation.accept.success': '邀请已接受。正在重定向到聊天...',
                'invitations.sent.title': '已发送的邀请',
                'invitations.sent.empty': '没有待处理的邀请',
                'invitations.pending.title': '待处理的邀请',
                'invitations.columns.email': '电子邮件',
                'invitations.columns.language': '语言',
                'invitations.columns.mode': '模式',
                'invitations.columns.status': '状态',
                'invitations.columns.sentAt': '已发送',
                'invitations.columns.actions': '操作',
                'invitations.status.pending': '待处理',
                'invitations.status.accepted': '已接受',
                'invitations.status.cancelled': '已取消',
                'invitations.status.expired': '已过期',
                'invitations.actions.cancel': '取消',
                'invitations.actions.copy': '复制链接',
                'invitations.actions.resend': '重新发送邮件',
                'profile.privacy.title': '隐私',
                'profile.privacy.public_visibility': '使我的个人资料公开可见',
                'profile.privacy.public_warning': '这允许任何ArChat®用户找到您并开始对话。',
                'profile.privacy.private_info': '您的个人资料是私密的。只有您邀请或邀请您的用户才能与您聊天。',
                'profile.privacy.private_default': '默认情况下，您的个人资料是私密的，以提高安全性。',
                'common.close': '关闭',
                'common.cancel': '取消',
                'common.confirm': '确认',
                'common.sending': '发送中',
                'common.save': '保存',
                'common.saving': '保存中...',
                'buttons.accept': '接受',
                'buttons.cancel': '取消',
                'buttons.save': '保存',
                'buttons.edit': '编辑',
                'buttons.retry': '重试',
                'buttons.confirm': '确认',
                'buttons.yes': '是',
                'buttons.no': '否',
                'buttons.send': '发送',
                'buttons.close': '关闭',
                'buttons.continue': '继续',
                'buttons.delete': '删除',
                'buttons.logout': '退出',
                'buttons.back': '返回',
                'buttons.update': '更新',
                'buttons.upload': '上传',
                'buttons.select': '选择',
                'conversation.backToContacts': '返回联系人',
                'help.title': 'ArChat® 帮助',
                'help.what.title': '什么是 ArChat®?',
                'help.what.description': 'ArChat®是一个书面消息系统，具有自动翻译功能，允许您与不会说您语言的人交流，从第一条消息开始保持清晰、上下文和隐私。',
                'help.how.title': '它是如何工作的?',
                'help.how.step1.title': '登录',
                'help.how.step1.description': '使用您的昵称和密码访问系统。如果您没有账户，将自动创建。',
                'help.how.step2.title': '邀请您的联系人',
                'help.how.step2.description': '从您的个人资料通过电子邮件邀请您的联系人。从一开始就定义语言和对话模式。',
                'help.how.step3.title': '用您的语言书写',
                'help.how.step3.description': '用您喜欢的语言编写消息。系统将自动翻译书面消息。',
                'help.how.step4.title': '对方收到翻译',
                'help.how.step4.description': '收件人自动收到翻译成其语言的消息，保持清晰和上下文。',
                'help.features.title': '主要功能',
                'help.features.translation': '🌐 语言之间的自动即时翻译',
                'help.features.status': '💬 在线状态（在线、空闲、请勿打扰等）',
                'help.features.statusCustom': '💬 自定义状态，带表情符号和个性化消息',
                'help.features.contacts': '👥 完整的联系人列表，带搜索和筛选',
                'help.features.contactsMobile': '📱 优化的移动视图，包含完整信息（姓氏、国家、状态）',
                'help.features.contactsFilter': '👁️ 显示/隐藏非收藏联系人的按钮 - 将列表减少到仅您的收藏',
                'help.features.contactAlias': '✏️ 每个联系人的自定义别名和私人笔记 - 点击对话中的联系人姓名',
                'help.features.themes': '🎨 两种可用主题：阿根廷（浅蓝/白/金色）和深色（深紫色）',
                'help.features.messages': '📨 实时消息传递，带已读指示器',
                'help.features.attachments': '📎 附加与书面交流兼容的文件：图片、视频和PDF文档',
                'help.features.camera': '📸 使用前置、后置摄像头或网络摄像头拍摄照片',
                'help.features.gallery': '🖼️ 从图库选择文件',
                'help.features.compression': '🗜️ 自动图像压缩和缩略图生成',
                'help.features.progress': '📊 文件上传期间的进度条',
                'help.features.delete': '🗑️ 删除您自己的消息',
                'help.features.scroll': '⬇️ 打开对话时自动滚动到最后一条消息',
                'help.features.profile': '👤 可自定义的个人资料，带头像、简介和偏好',
                'help.features.profileEdit': '✏️ 无中断的个人资料编辑（编辑时不刷新）',
                'help.features.countries': '🌍 195+个国家的完整列表，自动选择时区',
                'help.features.registration': '📧 通过电子邮件确认和安全验证码注册',
                'help.features.multilanguage': '🗣️ 支持多种语言（西班牙语、英语、葡萄牙语、法语、德语、意大利语、俄语、中文、日语、韩语、阿拉伯语、印地语）',
                'help.features.pwa': '📲 可在移动设备和桌面安装的 PWA 应用程序',
                'help.features.sync': '🔄 每 5 秒自动同步消息',
                'help.features.deleteSync': '🗑️ 自动同步跨设备删除的消息',
                'help.features.notifications': '🔔 收到新消息时的声音通知',
                'help.features.retranslation': '🔄 如果第一次失败，自动重新翻译消息',
                'help.features.preview': '👁️ 发送前预览文件',
                'help.features.security': '🔒 带有 CAPTCHA、浏览器指纹和速率限制的安全系统',
                'help.features.passwordRecovery': '🔑 通过电子邮件恢复密码',
                'help.features.emailConfirmation': '📧 通过电子邮件确认账户，包含激活链接',
                'help.features.invitations': '📧 私人电子邮件邀请 - 邀请外部联系人，定义语言和上下文',
                'help.features.invitationsManagement': '📋 完整的邀请管理 - 从菜单中列出、重新发送或取消待处理的邀请',
                'help.features.contactStatus': '🏷️ 可见的联系人状态 - 查看每个联系人的状态（待处理、已注册、准备聊天）',
                'help.features.favorites': '⭐ 收藏夹系统 - 将联系人标记为收藏以便快速访问',
                'help.features.profilePhoto': '📸 改进的个人资料照片上传 - 从图库中选择图像，立即预览',
                'help.features.translationSender': '👁️ 发送者的翻译视图 - 查看您的消息如何翻译成收件人的语言',
                'help.features.unifiedContacts': '🔗 统一的联系人模型 - 联系人来自邀请和现有对话',
                'help.features.privacy': '🔒 默认隐私模式 - 您的个人资料是私密的，只能通过直接邀请访问',
                'help.features.export': '💾 对话导出 - 将完整对话导出为PDF或HTML，包含图片和文件',
                'help.tips.title': '有用提示',
                'help.tips.language': '✅ 在您的个人资料中设置首选语言以接收正确翻译的消息',
                'help.tips.status': '✅ 更新您的在线状态，以便其他人了解您的可用性',
                'help.tips.statusCustom': '✅ 创建带表情符号和消息的自定义状态以表达您当前的状态',
                'help.tips.search': '✅ 标记收藏（星号）并通过"用户"模态框阻止用户',
                'help.tips.contactsFilter': '✅ 使用顶部栏中的眼睛按钮（👁️）显示或隐藏非收藏的联系人',
                'help.tips.contactAlias': '✅ 点击对话中的联系人姓名以添加自定义别名和私人笔记',
                'help.tips.avatar': '✅ 点击联系人的头像以查看大图',
                'help.tips.messages': '✅ 当您有未读消息时，ArChat®图标会闪烁',
                'help.tips.attachments': '✅ 使用回形针按钮（📎）附加图片、视频或PDF；与书面交流兼容',
                'help.tips.camera': '✅ 使用相机直接从应用程序拍摄照片',
                'help.tips.compression': '✅ 图像会自动压缩以节省空间',
                'help.tips.delete': '✅ 您可以点击删除按钮删除您自己的消息',
                'help.tips.profile': '✅ 放心编辑您的个人资料：系统在您编辑时不会刷新',
                'help.tips.themes': '✅ 从设置 > 外观更改主题：阿根廷（浅蓝色）或深色（深紫色）',
                'help.tips.country': '✅ 在个人资料中选择您的国家，以便自动配置时区',
                'help.tips.registration': '✅ 注册时，验证您的电子邮件以完全激活您的账户',
                'help.tips.writing': '✅ 编写清晰的消息：ArChat®翻译书面文本的含义，保持上下文和清晰度',
                'help.tips.invitations': '✅ 从您的个人资料通过电子邮件邀请联系人 - 从一开始就定义语言和对话模式',
                'help.tips.invitationsManagement': '✅ 从"已发送邀请"菜单管理您的邀请 - 重新发送电子邮件或取消待处理的邀请',
                'help.tips.contactStatus': '✅ 观察列表中每个联系人的状态 - 待处理（橙色）、已注册（绿色）或活跃对话（蓝色）',
                'help.tips.favorites': '✅ 用星号 ⭐ 将联系人标记为收藏 - 收藏夹首先出现在您的列表中',
                'help.tips.profilePhoto': '✅ 从"从图库选择"上传您的个人资料照片 - 保存前您会看到预览',
                'help.tips.translationSender': '✅ 发送消息时，展开翻译面板以查看如何将其翻译成收件人的语言',
                'help.tips.unifiedContacts': '✅ 当联系人接受邀请或您与他们有对话时，您的联系人会自动显示',
                'help.tips.privacy': '✅ 您的个人资料默认是私密的 - 如果您希望其他人找到您，请在个人资料 > 隐私中启用公开可见性',
                'help.tips.export': '✅ 使用标题中的 ⬇️ 按钮导出完整对话 - 选择包含所有图片的PDF或HTML',
                'help.support.title': '支持',
                'help.support.description': '如果您有问题或疑问，请联系系统管理员或查看可用的技术文档。',
                'help.about.title': '关于',
                'help.about.developer': '开发者:',
                'help.about.location': 'MDQ - 阿根廷',
                'help.about.linkedin': '查看 LinkedIn 个人资料',
                'presence.title': '在线状态',
                'presence.currentStatus': '当前状态:',
                'presence.changeStatus': '更改状态',
                'presence.status.online': '在线',
                'presence.status.online.title': '在线 - 所有人可见',
                'presence.status.online.description': '在线: 所有联系人可见',
                'presence.status.idle': '空闲',
                'presence.status.idle.title': '空闲 - 表示暂时离开',
                'presence.status.idle.description': '空闲: 表示您暂时不可用',
                'presence.status.dnd': '请勿打扰',
                'presence.status.dnd.title': '请勿打扰 - 表示您不希望被打扰',
                'presence.status.dnd.description': '请勿打扰: 表示您不希望被打扰的可见标识',
                'presence.status.busy': '忙碌',
                'presence.status.busy.title': '忙碌 - 不可用',
                'presence.status.busy.description': '忙碌: 不可用',
                'presence.status.offline': '离线',
                'presence.status.offline.title': '已断开 - 显示为离线',
                'presence.status.offline.description': '离线: 显示为已断开',
                'presence.status.custom': '自定义',
                'presence.status.custom.title': '自定义 - 带表情符号的独特状态',
                'presence.status.custom.description': '自定义: 带表情符号和可选过期时间的独特状态',
                'dashboard.title': '仪表盘',
                'dashboard.planUsage': '套餐用量',
                'dashboard.filesSummary': '我的文件',
                'dashboard.promotions': '促销',
                'dashboard.sessions': '活动会话',
                'dashboard.explore': '探索',
                'dashboard.noSessions': '无活动会话',
                'dashboard.welcomeTitle': '欢迎使用 ArChat®',
                'dashboard.welcomeSubtitle': '用任何语言轻松沟通。',
                'dashboard.stepInvite': '第 1 步：邀请第一位联系人',
                'dashboard.stepMessage': '第 2 步：发送第一条消息',
                'dashboard.inviteContact': '邀请联系人',
                'dashboard.exploreArChat': '探索 ArChat',
                'dashboard.promotionsTitle': '促销与奖励',
                'dashboard.promotionsText': '推荐与奖励计划概览。',
                'dashboard.viewPromotions': '查看促销',
                'dashboard.usageTitle': '套餐使用情况',
                'dashboard.sessionsTitle': '活动会话',
                'dashboard.sessionsEmpty': '暂无活动会话',
                'dashboard.filesTitle': '我的文件',
                'dashboard.viewFiles': '查看我的文件',
                'dashboard.noBlocks': '没有已启用的模块。请在设置中至少打开一个。',
                'dashboard.openSettings': '打开设置',
                'dashboard.goToContacts': '前往联系人',
                'dashboard.filesVisible': '可见文件数',
                'dashboard.filesSampleNote': '以上一页列表为准（最多 500+ 条）。',
                'dashboard.loading': '加载数据...',
                'dashboard.error.title': '错误',
                'dashboard.error.load': '无法加载使用数据',
                'dashboard.error.generic': '加载仪表板时出错',
                'dashboard.error.no_data': '无法加载数据',
                'dashboard.retry': '重试',
                'dashboard.unlimited': '无限制',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': '联系人',
                'dashboard.card.chars': '字符',
                'dashboard.card.chars_month': '本月字符数',
                'dashboard.card.storage': '存储',
                'dashboard.card.devices': '活动设备',
                'dashboard.upgrade.title': '需要更多资源？',
                'dashboard.upgrade.message': '升级计划以获得更多联系人、字符、存储和活动设备。',
                'dashboard.upgrade.button': '升级计划',
                'upgrade.title': '升级计划',
                'upgrade.close': '关闭',
                'upgrade.cancel': '取消',
                'upgrade.activate': '激活 PRO 计划',
                'upgrade.activating': '激活中...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': '计划比较',
                'upgrade.free.label': '免费计划',
                'upgrade.free.limits.contacts': '最多 2 个联系人',
                'upgrade.free.limits.conversations': '最多 2 个对话',
                'upgrade.free.limits.no_export': '无数据导出',
                'upgrade.free.limits.no_advanced': '无高级功能',
                'upgrade.pro.label': 'Pro 计划',
                'upgrade.pro.recommended': '推荐',
                'upgrade.pro.benefits.contacts': '无限联系人',
                'upgrade.pro.benefits.contacts.desc': '添加您需要的所有联系人，无限制',
                'upgrade.pro.benefits.conversations': '无限对话',
                'upgrade.pro.benefits.conversations.desc': '保持您需要的所有活动对话',
                'upgrade.pro.benefits.export': '对话导出',
                'upgrade.pro.benefits.export.desc': '以多种格式导出您的对话（PDF、TXT、JSON）',
                'upgrade.pro.benefits.notifications': '高级通知',
                'upgrade.pro.benefits.notifications.desc': '个性化通知和高级配置',
                'upgrade.pro.benefits.translation': '无限自动翻译',
                'upgrade.pro.benefits.translation.desc': '无使用限制地翻译消息',
                'upgrade.pro.benefits.files': '无限文件发送',
                'upgrade.pro.benefits.files.desc': '无限制地共享任何大小的文件',
                'upgrade.pro.benefits.themes': '个性化主题',
                'upgrade.pro.benefits.themes.desc': '访问所有主题和高级自定义',
                'upgrade.pro.benefits.security': '高级安全',
                'upgrade.pro.benefits.security.desc': '额外保护和增强的隐私功能',
                'upgrade.pro.benefits.analytics': '统计和分析',
                'upgrade.pro.benefits.analytics.desc': '访问您活动的详细统计信息',
                'upgrade.pro.benefits.priority': '优先支持',
                'upgrade.pro.benefits.priority.desc': '优先关注和快速响应您的查询',
                'upgrade.enterprise.label': '企业计划',
                'upgrade.enterprise.benefits.contacts': '无限联系人',
                'upgrade.enterprise.benefits.support': '24/7 优先支持',
                'upgrade.enterprise.benefits.custom': '定制解决方案',
                'upgrade.enterprise.benefits.advanced': '高级企业功能',
                'upgrade.enterprise.benefits.integration': '定制集成',
                'upgrade.enterprise.benefits.dedicated': '专属支持',
                'upgrade.success.title': 'PRO 计划已激活',
                'upgrade.success.message': '您的计划已更新为 PRO。享受所有无限制功能。',
                'upgrade.error.title': '激活 PRO 时出错',
                'upgrade.error.message': '无法更新计划。请重试。',
                'upgrade.error.generic': '发生意外错误。请重试。',
                'upgrade.benefits.contacts': '无限联系人',
                'upgrade.benefits.contacts.desc': '添加您需要的所有联系人，无限制',
                'upgrade.benefits.conversations': '无限对话',
                'upgrade.benefits.conversations.desc': '保持您需要的所有活动对话',
                'upgrade.benefits.export': '对话导出',
                'upgrade.benefits.export.desc': '以多种格式导出您的对话（PDF、TXT、JSON）',
                'upgrade.benefits.notifications': '高级通知',
                'upgrade.benefits.notifications.desc': '个性化通知和高级配置',
                'upgrade.benefits.translation': '无限自动翻译',
                'upgrade.benefits.translation.desc': '无使用限制地翻译消息',
                'upgrade.benefits.files': '无限文件发送',
                'upgrade.benefits.files.desc': '无限制地共享任何大小的文件',
                'upgrade.benefits.themes': '个性化主题',
                'upgrade.benefits.themes.desc': '访问所有主题和高级自定义',
                'upgrade.benefits.security': '高级安全',
                'upgrade.benefits.security.desc': '额外保护和增强的隐私功能',
                'upgrade.benefits.analytics': '统计和分析',
                'upgrade.benefits.analytics.desc': '访问您活动的详细统计信息',
                'upgrade.benefits.priority': '优先支持',
                'upgrade.benefits.priority.desc': '优先关注和快速响应您的查询',
                'upgrade.limits.contacts': '最多 2 个联系人',
                'upgrade.limits.conversations': '最多 2 个对话',
                'upgrade.limits.no_export': '无数据导出',
                'upgrade.limits.no_advanced': '无高级功能',
                // API Error Messages
                'api.error.image_processing_not_available': '服务器上不可用图像处理',
                'api.error.image_functions_not_available': '图像处理功能不可用',
                'api.error.method_not_allowed': '不允许的方法',
                'api.error.user_not_identified': '用户未识别',
                'api.error.upload_file_too_large_php': '文件超过PHP允许的最大大小',
                'api.error.upload_file_too_large_form': '文件超过表单允许的最大大小',
                'api.error.upload_file_partial': '文件部分上传',
                'api.error.upload_no_file': '未上传文件',
                'api.error.upload_no_temp_dir': '缺少临时目录',
                'api.error.upload_cant_write': '写入磁盘文件时出错',
                'api.error.upload_extension_stopped': 'PHP扩展停止了上传',
                'api.error.upload_generic': '文件上传错误',
                'api.error.file_type_not_allowed': '不允许的文件类型。仅允许图像（JPEG、PNG、GIF、WEBP）',
                'api.error.file_too_large': '文件太大（最大10MB）',
                'api.error.storage_limit_exceeded': '存储限制已超出。升级您的计划以上传更多文件。',
                'api.error.user_not_found': '未找到用户或用户未激活',
                'api.error.image_directory_access': '访问图像目录时出错',
                'api.error.file_extension_not_allowed': '不允许的文件扩展名',
                'api.error.temp_file_save': '保存临时文件时出错',
                'api.error.image_processing': '处理图像时出错',
                'api.error.database_update': '更新数据库时出错',
                'api.error.internal_server_error': '内部服务器错误',
                'api.error.internal_server_error_debug': '内部服务器错误',
                'api.error.user_id_required': '需要用户ID',
                'api.error.profile_not_found': '未找到个人资料',
                'api.error.profile_load_failed': '加载个人资料时出错',
                'api.error.invalid_data': '无效数据',
                'api.error.validation_errors': '验证错误',
                'api.error.profile_update_failed': '无法更新个人资料',
                'api.error.profile_update_error': '更新个人资料时出错',
                // API Success Messages
                'api.success.photo_updated': '照片已更新',
                'api.success.profile_loaded': '个人资料加载成功',
                'api.success.profile_updated': '个人资料更新成功',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': '设备限制已达到',
                'errors.deviceLimit.solution': '要继续，请从其他设备退出登录或升级您的计划。',
                // Error Messages - Network
                'errors.network.title': '连接错误',
                'errors.network.message': '无法连接到服务器。请检查您的互联网连接。',
                // Error Messages - Server
                'errors.server.invalidResponse.title': '服务器错误',
                'errors.server.invalidResponse.message': '服务器返回了无效响应。请重试。',
                // Error Messages - Generic
                'errors.generic.title': '错误',
                'errors.generic.message': '发生错误。请重试。',
                'errors.generic.403.title': '访问错误',
                'errors.generic.403.message': '您没有执行此操作的权限。',
                'errors.saas_max_users': '已达到计划用户限制 ({current}/{limit}).',
                'errors.tenant_frozen': '租户暂时被封锁。',
                'errors.auth_invalid_credentials': '用户名或密码错误。',
                'errors.accountInactive.title': '账户未激活。请输入邮箱以重新激活。',
                'errors.accountInactive.activate': '立即激活',
                'errors.accountInactive.accept': '接受',
                'errors.accountInactive.success': '账户已激活。您现在可以登录。',
                'errors.accountInactive.fail': '无法激活账户。请重试。',
                'errors.accountInactive.completeSuccess': '已使用您的邮箱激活账户。您现在可以登录。',
                'errors.accountInactive.completeFail': '无法完成激活。请检查邮箱后重试。',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': '计划限制已达到',
                'plan.errors.deviceLimit.message': '您当前的计划对可同时连接的设备数量有限制。',
                'plan.errors.deviceLimit.solution': '要继续，请从其他设备退出登录或将您的计划升级到PRO。',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': '联系人限制已达到',
                'plan.errors.contactsLimit.message': '您当前的计划对可以拥有的联系人数量有限制。',
                'plan.errors.contactsLimit.solution': '要添加更多联系人，请将您的计划升级到PRO。',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': '邀请限制已达到',
                'plan.errors.invitationsLimit.message': '您当前的计划对每天可以发送的邀请数量有限制。',
                'plan.errors.invitationsLimit.solution': '要发送更多邀请，请将您的计划升级到PRO。',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': '消息限制已达到',
                'plan.errors.messagesLimit.message': '您当前的计划对每天可以发送的消息数量有限制。',
                'plan.errors.messagesLimit.solution': '要发送更多消息，请将您的计划升级到PRO。',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': '存储限制已达到',
                'plan.errors.storageLimit.message': '您当前的计划对可用存储量有限制。',
                'plan.errors.storageLimit.solution': '要获得更多存储空间，请将您的计划升级到PRO。',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': '需要升级计划',
                'plan.errors.upgradeRequired.message': '此功能需要比您当前计划更高级的计划。',
                'plan.errors.upgradeRequired.solution': '将您的计划升级到PRO以访问此功能。',
                "appearance.theme.system": "系统",
                "appearance.theme.corporate": "公司的",
                "theme.system": "系统",
                "theme.corporate": "公司的",
                'founder.title': 'FOUNDATION (创始人)',
                'founder.subtitle': '以终身价格从项目起步即支持我们。',
                'founder.whatIs': '前150名用户以优惠终身价格获得 FOUNDATION 计划。',
                'founder.howItWorks': '您的创始人等级取决于您的位置（1至150）。',
                'founder.benefitsTitle': '权益',
                'founder.benefitPrice': '每月 $15（Founder 价格）',
                'founder.benefitFeatures': '包含 PRO 计划全部功能。',
                'founder.limit': '仅限150个创始人名额。',
                'founder.cancelRule': '若取消订阅，在未订阅期间将失去创始人身份。',
                'founder.rejoinRule': '若再次有名额，您可重新激活并自动恢复创始人身份。',
                'founder.tiers.title': '创始人等级',
                'founder.tiers.legendary.name': '传奇创始人',
                'founder.tiers.legendary.range': '位置 1–25',
                'founder.tiers.legendary.desc': '最早支持项目者。最高历史优先级。',
                'founder.tiers.early.name': '早期创始人',
                'founder.tiers.early.range': '位置 26–75',
                'founder.tiers.early.desc': '早期支持，享有特别认可。',
                'founder.tiers.founder.name': '创始人',
                'founder.tiers.founder.range': '位置 76–150',
                'founder.tiers.founder.desc': '150个名额内的创始人席位。',
                'founder.whatIsLink': '什么是创始人？',
                'founder.viewTiers': '查看创始人等级',
                'founder.modalClose': '关闭',
                'founder.activeCountLabel': '位创始人已加入',
                'founder.urgency.lastSlots': '最后一批创始人名额',
                "founder.positionLabel": "创始人#{position} / {limit}",
                'founder.leaderboard.title': '顶尖创始人',
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "确认链接将发送到您的电子邮件",
                "auth.user_not_found": "未找到用户。",
                "auth.user_inactive": "您的帐户已停用。联系管理员。",
                "auth.tenant_mismatch": "您的帐户不属于此环境。联系管理员。",
                "auth.captcha_required": "您必须完成安全验证 (CAPTCHA)。",
                "mail.send_failed": "无法发送恢复电子邮件。检查您的 SMTP 设置或稍后重试。",
                "auth.resend_activation": "重新发送激活邮件",
                "register.creatingAccount": "创建您的帐户...",
                "common.edit": "编辑",
                "common.on": "活性",
                "common.off": "残疾人",
                "common.refresh": "更新",
                "system.processing": "加工...",
                "captcha.incorrect": "验证码答案不正确。",
                "captcha.placeholder": "写下答案",
                "captcha.questionFormat": "{a} + {b} 是什么？",
                'menu.admin': '管理',
                'navbar.status': '状态',
                "navbar.users": "用户",
                'navbar.no_blocked_users': '暂无已屏蔽用户',
                'navbar.blocked_users_title': '已屏蔽用户',
                'contacts.blocked_users_title': '已屏蔽用户',
                'contacts.country_label': '国家',
                'contacts.not_reported': '未填写',
                "navbar.user_fallback": "用户身份}",
                "navbar.open_guide": "指导",
                "help.how_archat_works": "ArChat® 的工作原理",
                "help.registration": "记录",
                "help.private_invitations": "私人邀请",
                "help.messaging": "消息传递",
                "help.security": "安全",
                "invitation.quick_button": "邀请联系",
                "onboarding.title": "欢迎来到ArChat®",
                "onboarding.subtitle": "用任何语言与任何人交流。",
                "onboarding.step1.label": "步骤1",
                "onboarding.step1.text": "邀请您的第一个联系人",
                "onboarding.step2.label": "步骤2",
                "onboarding.step2.text": "发送您的第一条消息",
                "onboarding.actions.invite": "邀请联系",
                "onboarding.actions.explore": "探索 ArChat®",
                'suggestions.sendSuccess': '您的建议已成功发送。',
                'suggestions.sendError': '无法发送建议，请重试。',
                'suggestions.sent': '建议已成功发送。',
                'errors.suggestionSend': '无法发送建议，请重试。',
                'app.install': '安装 ArChat',
                'menu.open': '菜单',
                "contacts.controls.hide_non_favorites": "隐藏不常用的联系人",
                "contacts.controls.show_all": "显示所有联系人",
                "common.navigation": "导航",
                "common.favorite": "最喜欢的",
                "common.block": "堵塞",
                "common.user": "用户",
                "message.new": "新消息",
                "message.edit": "编辑留言",
                "message.edit.save": "保存编辑",
                "message.edit.cancel": "取消编辑",
                'message.translating': '翻译中...',
                'message.translation_failed': '无法翻译',
                'message.not_translated': '原文',
                'message.retry_send': '重试',
                'message.retrying': '正在重试...',
                "message.delete": "删除留言",
                'message.deleted_placeholder': '消息已删除',
                "message.edited": "已编辑",
                "message.edited_at": "编辑于",
                'message.delete_for_me.tooltip': '仅对我删除',
                'message.delete_for_me.aria': '仅为我删除这条消息',
                'message.delete_for_me.confirm_title': '删除消息',
                'message.delete_for_me.confirm_message': '此消息只会从你的视图中删除。',
                'message.delete_for_everyone.tooltip': '为所有人删除',
                'message.delete_for_everyone.aria': '为所有参与者删除这条消息',
                'message.delete_for_everyone.confirm_title': '为所有人删除消息',
                'message.delete_for_everyone.confirm_message': '此消息将从你和另一位参与者的视图中删除。',
                'message.delete_for_everyone.window_expired': '删除窗口已过期',
                "message.translation.show": "查看原文和译文",
                "message.translation.hide": "隐藏翻译",
                "emoji.search": "搜索表情符号",
                "emoji.close": "关闭选择器",
                "captcha.refresh": "重新生成验证码",
                'presence.unavailable': 'Status zan bu ke yong',
                'presence.maintenance': 'Fu wu qi wei hu zhong',
                "home.access_nav": "访问应用程序",
                "common.requiredFields": "填写所有必填字段。",
                "bio.view": "参见传记",
                "profile.nick.readonly": "用户名不能修改",
                "profile.nick.readonly.help": "用户名唯一且不可修改",
                "profile.email.readonly": "邮箱无法修改",
                "profile.email.readonly.help": "电子邮件是唯一的，无法修改",
                "profile.invitations.title": "邀请函",
                "profile.invitations.validated": "已验证的邀请",
                "profile.invitations.nextBadge": "下一个成就",
                "profile.invitations.progress": "进步",
                "profile.invitations.achievement": "成就",
                "profile.invitations.topInviterAchieved": "已达到最大邀请人数",
                "profile.invitations.badges.networkBuilder": "网络建设者",
                "profile.invitations.badges.topInviter": "最大邀请人数",
                "profile.invitations.achievement.networkBuilderMessage": "您在 ArChat 上邀请了 20 位用户。",
                "profile.invitations.achievement.topInviterMessage": "您在 ArChat 上邀请了 50 位用户。",
                "profile.plan.loading_info": "正在加载计划信息...",
                "profile.plan.valid_until": "有效期至：",
                "profile.plan.active_since": "活跃时间：",
                "profile.plan.active_badge": "✓ 活跃",
                "profile.manage_plan": "管理计划",
                "plan.current_plan": "目前计划",
                "plan.current": "Actual",
                'plan.footer_prefix': '方案：',
                "plan.upgrade_to_pro": "升级到专业版",
                "plan.upgrade_to_foundation": "升级至基础版",
                "plan.payment_coming": "使用 Paddle 付款即将推出。您可以从这里更改计划。",
                "plan.payment_coming_title": "很快",
                "plan.foundation_full": "FOUNDATION 配额已满（150 名创始人）。您可以选择专业版。",
                "plan.sold_out": "筋疲力尽的",
                "plan.founder_spots_remaining": "仅 {count} 个名额",
                "plan.founders_occupied": "忙碌的创始人",
                "plan.upgrade_not_allowed": "只有拥有免费计划的用户才能请求升级。",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "联系方式",
                "billing.usage.chars_month": "每月字符数",
                "billing.usage.storage": "已用存储",
                "billing.usage.devices": "连接设备",
                "billing.loading": "收费...",
                'billing.subscription.section_title': '订阅与账单',
                'billing.subscription.provider_note': '提供商',
                'billing.subscription.paddle_active': 'Paddle（应用内生效方案）',
                'billing.subscription.mp_action_ok': '请求已记录。若未打开结账页，请检查网络或重试。',
                'billing.paddle.manage_subscription_button': '管理订阅',
                'billing.paddle.portal_confirm_title': '账单门户',
                'billing.paddle.portal_confirm': '将打开安全的 Paddle 门户，用于更新付款方式、发票或取消订阅。是否继续？',
                'billing.paddle.portal_opened_hint': '已在新的标签页打开 Paddle 门户。若方案未更新，请刷新个人资料。',
                'billing.paddle.portal_error': '无法打开 Paddle 门户。请稍后重试或联系支持。',
                'billing.paddle.no_link_error': '账户尚无 Paddle 订阅关联。若刚完成付款，请等待 webhook 或联系支持。',
                'billing.paddle.api_not_configured': '服务器缺少 Paddle API 配置（PADDLE_API_KEY）。需由管理员设置。',
                "billing.descriptions.contacts": "您帐户中存储的联系人总数",
                "billing.descriptions.storage": "用于文件和媒体的存储",
                "billing.descriptions.chars_month": "本月翻译的人物",
                "billing.descriptions.devices": "活动连接设备",
                'billing.paddle.return_title': '已收到付款',
                'billing.paddle.return_body': '若您已完成结账，Paddle 确认后方案将很快更新。您可以返回应用首页。',
                'billing.paddle.verifying': '正在核对您的方案…',
                'billing.paddle.not_logged_in': '请登录以查看最新的方案状态。',
                'billing.paddle.plan_updated': '方案已更新：{plan}',
                'billing.paddle.plan_current': '您当前的方案：{plan}',
                'billing.paddle.plan_current_founder': '您已成为 Founder — {plan}',
                'billing.paddle.still_free_hint': '若稍等仍显示 FREE，可能是 webhook 延迟。请查看后端日志或刷新页面。',
                'billing.paddle.pro_extra_hint': '您可以返回首页使用方案。',
                "profile.photo.select": "选择照片",
                "profile.photo.select.gallery": "从图库中选择",
                "avatar.errors.too_large": "图像太大。最大大小：2 MB。",
                "avatar.preview.title": "头像预览",
                "profile.avatar.error_title": "无法更新头像",
                "profile.avatar.error.title": "无法更新头像",
                "profile.avatar.error.size": "图片超出了允许的尺寸。最大值为 2 MB。",
                "profile.avatar.tooLarge.title": "图片太大",
                "profile.avatar.tooLarge.message": "照片超出了允许的尺寸。最大值为 2 MB。",
                "profile.avatar.uploadError.title": "无法更新头像",
                "profile.avatar.uploadError.message": "上传图片时出现问题。再试一次。",
                "profile.saveSuccess.title": "更新个人资料",
                "profile.saveSuccess.message": "您的更改已成功保存。",
                "profile.avatar.file_too_large": "图像超出允许的最大大小 (2 MB)。",
                "profile.avatar.file_too_large_hint": "选择较亮的图像或缩小其尺寸，然后重试。",
                "profile.photo.take.front": "前置摄像头",
                "profile.photo.take.back": "后置摄像头",
                "profile.photo.take.webcam": "摄像头",
                "profile.photo.camera.front": "前置摄像头",
                "profile.photo.camera.back": "后置摄像头",
                "profile.photo.camera.web": "摄像头",
                "profile.photo.close": "关闭",
                "profile.photo.capture": "捕获",
                "block.toggle_error": "无法锁定或解锁。",
                "contact.favorite.add": "添加到收藏夹",
                "contact.favorite.remove": "从收藏夹中删除",
                "contact.block.block": "堵塞",
                'contact.block.unblock': '解除屏蔽',
                "conversation.notFound": "找不到对话",
                "help.howWorks.title": "👥 ArChat® 的工作原理（真实流程）",
                "help.howWorks.step1.title": "1️⃣ 注册",
                "help.howWorks.step1.point1": "使用您的昵称和密码登录。",
                "help.howWorks.step1.point2": "如果您没有帐户，系统会自动创建帐户。",
                "help.howWorks.step1.point3": "您接受您语言的条款和条件。",
                "help.howWorks.step1.point4": "您通过电子邮件确认您的帐户。",
                "help.howWorks.step2.title": "2️⃣ 私人邀请",
                "help.howWorks.step2.point1": "通过您的个人资料中的电子邮件邀请联系人。",
                "help.howWorks.step2.point2": "在开始之前定义语言和对话模式。",
                "help.howWorks.step2.point3": "联系人收到私人邀请。",
                "help.howWorks.step2.point4": "您可以查看是否为：待定、已注册、准备聊天",
                "help.howWorks.step2.point5": "联系不是寻求的，而是邀请的。",
                "help.howWorks.step2.point6": "联系不是寻求的，而是邀请的。",
                "help.howWorks.step3.title": "3️⃣ 联系方式和对话",
                "help.howWorks.step3.point1": "在以下情况下，您的联系人会自动显示：",
                "help.howWorks.step3.point2": "接受邀请",
                "help.howWorks.step3.point3": "或者有一段对话",
                "help.howWorks.step3.point4": "能：",
                "help.howWorks.step3.point5": "将它们标记为最爱 ⭐",
                "help.howWorks.step3.point6": "为他们分配自定义别名",
                "help.howWorks.step3.point7": "添加私人笔记",
                "help.howWorks.step3.point8": "阻止或管理它​​们",
                "help.howWorks.step3.point9": "未经同意，不存在公共议程或可见用户。",
                "help.howWorks.step4.title": "4️⃣ 带翻译的消息传递",
                "help.howWorks.step4.point1": "始终用您的语言写作。",
                "help.howWorks.step4.point2": "系统自动翻译该消息。",
                "help.howWorks.step4.point3": "收件人以他们的语言收到它。",
                "help.howWorks.step4.point4": "您可以看到应用的翻译。",
                "help.howWorks.step4.point5": "如果翻译失败，会自动重试。",
                "help.howWorks.step4.point6": "ArChat® 优先考虑清晰度和意义，而不仅仅是速度。",
                "help.privacy.title": "🔒 隐私和控制",
                "help.privacy.point1": "默认情况下，您的个人资料是私人的。",
                "help.privacy.point2": "只有您邀请的人才能看到您或给您写信。",
                "help.privacy.point3": "公共可见性是可选的，默认情况下处于禁用状态。",
                "help.privacy.point4": "主动安全性：",
                "help.privacy.point5": "验证码",
                "help.privacy.point6": "速率限制",
                "help.privacy.point7": "指纹",
                "help.privacy.point8": "电子邮件验证",
                "help.privacy.point9": "您的对话不公开或未编入索引。",
                "help.files.title": "📎 文件和导出",
                "help.files.point1": "附加图像、视频和 PDF 文档。",
                "help.files.point2": "使用前置摄像头、后置摄像头或网络摄像头拍摄照片。",
                "help.files.point3": "图像会自动压缩。",
                "help.files.point4": "发送前预览。",
                "help.files.point5": "加载期间的进度条。",
                "help.files.point6": "将整个对话导出到：",
                "help.files.point7": "PDF",
                "help.files.point8": "网页",
                "help.files.point9": "包括消息、图像和文件。",
                "help.files.point10": "您的数据是您的。",
                "help.experience.title": "🎨 用户体验",
                "help.experience.point1": "状态和带有表情符号的自定义状态。",
                "help.experience.point2": "集成 OpenMoji 表情符号。",
                "help.experience.point3": "读写指标。",
                "help.experience.point4": "优化的移动端视图与桌面端相同。",
                "help.experience.point5": "可安装的 PWA 应用程序。",
                "help.experience.point6": "两个主题：阿根廷（浅蓝色/白色/金色）和奥斯库罗（深紫色）。",
                "help.experience.point7": "无需软饮料即可编辑个人资料。",
                "help.experience.point8": "带自动时区的国家/地区选择器。",
                "help.experience.point9": "通过收藏夹、搜索和过滤器快速访问。",
                "help.languages.title": "🌍 语言",
                "help.languages.point1": "支持 {count} 种语言。",
                "help.languages.point2": "带标志的视觉选择器。",
                "help.languages.point3": "界面、条款和条件以及电子邮件均适应所选语言。",
                "help.languages.point4": "用户之间的双向自动翻译。",
                "help.tipsNew.title": "💡 利用 ArChat® 的技巧",
                "help.tipsNew.point1": "只邀请您真正想与之交流的人。",
                "help.tipsNew.point2": "使用别名和私人注释来组织联系人。",
                "help.tipsNew.point3": "标记收藏夹以便快速访问。",
                "help.tipsNew.point4": "在发送重要消息之前检查翻译。",
                "help.tipsNew.point5": "导出相关对话以进行备份或工作。",
                "help.tipsNew.point6": "当书写清晰度至关重要时，请使用 ArChat®。",
                "help.whySubscribe.title": "🚀 为什么订阅 ArChat®",
                "help.whySubscribe.point1": "ArChat® 并非旨在与任何人聊天，",
                "help.whySubscribe.point2": "而是为了与重要的人更好地沟通。",
                "help.whySubscribe.point3": "如果您需要：",
                "help.whySubscribe.point4": "语言之间的清晰度",
                "help.whySubscribe.point5": "真正的隐私",
                "help.whySubscribe.point6": "接触控制",
                "help.whySubscribe.point7": "对话导出",
                "help.whySubscribe.point8": "专业且无噪音的体验",
                "help.whySubscribe.point9": "ArChat® 就是为此而设计的。",
                "help.message_time_context.title": "消息的时间上下文",
                "help.message_time_context.description": "每条消息都可以保存发送者发送时的本地时间、时区和国家。这样您就可以看到其他用户发送的地点和时间。",
                "help.message_time_context.point1": "在免费计划中，仅显示您所在时区（接收器）的时间。",
                "help.message_time_context.point2": "PRO计划中还显示了发行人的当地时间、国家和时区。",
                "help.message_time_context.point3": "上下文历史记录保存在每条消息中。",
                "help.message_time_context.point4": "高级审计功能可在更高的计划中使用。",
                "help.tips.install": "✅ 在您的设备上安装 ArChat® 作为 PWA 应用程序，以便快速访问桌面",
                "help.tips.sync": "✅ 消息每 5 秒自动同步 - 无需刷新",
                "help.tips.deleteSync": "✅ 如果您删除一条消息，该消息将在所有收件人的设备上自动删除",
                "help.tips.notifications": "✅ 当您收到其他用户的新消息时，您会听到声音",
                "help.tips.retranslation": "✅ 如果消息翻译不正确，系统将尝试自动重新翻译",
                "help.tips.preview": "✅ 发送前检查文件预览以确保其正确",
                "help.tips.passwordRecovery": "✅ 如果您忘记了密码，请使用链接“忘记密码？”在登录中",
                "help.tips.emailConfirmation": "✅ 注册后检查您的电子邮件并点击确认链接",
                "help.tips.languageChange": "✅ 从标记选择器更改您的语言：条款和条件、电子邮件和 UI 立即更新",
                "help.tips.inputFixed": "✅ 在 PC 上，书写栏固定在屏幕底部，更加舒适",
                'presence.custom.title': 'Zi ding yi zhuang tai',
                'presence.custom.status': 'Zi ding yi zhuang tai',
                'presence.custom.placeholder': 'Li ru: He ka fei zhong ☕',
                'presence.custom.emoji': 'Emoji (ke xuan)',
                'presence.custom.emojiHelp': 'Xuan ze yi ge emoji huo shu ru yi ge',
                'presence.custom.temporary': 'Lin shi zhuang tai (zi dong guo qi)',
                'presence.custom.expiration': 'Guo qi shi jian',
                'presence.custom.expirationHelp': 'Guo qi hou zhuang tai jiang hui dao "Online"',
                'presence.custom.suggestions': 'Jian yi',
                'presence.custom.preview': 'Yu lan',
                'presence.custom.save': 'Bao cun zhuang tai',
                'presence.custom.required': 'Bi xu tian xie zi ding yi zhuang tai',
                'presence.custom.maxLength': 'Zui duo 64 ge zi fu',
                'presence.custom.expirationRequired': 'Ni bi xu xuan ze guo qi shi jian',
                'presence.custom.expirationFuture': 'Guo qi shi jian bi xu shi wei lai',
                'presence.custom.selectEmoji': 'Xuan ze emoji',
                "invitation.success.title": "邀请已发送",
                "invitation.success.message": "邀请已成功发送。\\n\\n联系人将收到一封电子邮件，其中包含接受邀请的链接。一旦接受，您就可以开始与他聊天。",
                "invitation.top.title": "顶级网络建设者",
                "invitation.top.invitesSuffix": "邀请函",
                "invitation.ranking.position": "位置",
                "invitation.ranking.user": "用户",
                "invitation.ranking.validatedInvites": "已验证的邀请",
                "invitation.ranking.empty": "没有可显示的经过验证的邀请。",
                "invitation.ranking.loading": "正在加载排名...",
                "invitation.ranking.loadError": "无法加载排名。",
                "invitations.waitBeforeResend": "您尚无法重新发送邀请。每次发送之间必须等待 10 分钟，以避免向访客用户发送垃圾邮件。",
                "invitations.captchaQuestion": "%1 + %2 是多少？",
                "invitations.resendSuccess": "邀请已成功转发。",
                "invitations.dailyLimit": "您今天已达到允许重新提交的最大数量。",
                "invitations.invalidEmail": "邮件服务器报告该地址无效。",
                "achievement.unlocked": "成就已解锁",
                "achievement.continue": "继续",
                'dashboard.not_available': '不可用',
                "plan.errors.chatsLimit.title": "已达到会话限制",
                "plan.errors.chatsLimit.message": "您当前的计划对您可以进行的对话数量有限制。",
                "plan.errors.chatsLimit.solution": "要创建更多对话，请将您的计划升级到 PRO。",
                "errors.generic": "发生意外错误。再试一次。",
                "errors.modal.title": "错误",
                "errors.modal.copyDetails": "复制详细信息",
                "errors.modal.close": "关闭",
                "errors.modal.reportSupport": "向支持人员报告",
                "errors.avatarTooLarge": "图像超过允许的 2MB 大小。",
                "errors.avatarTooLarge.title": "图片太大",
                "errors.avatarTooLarge.message": "图像超过允许的 2MB 大小。",
                "errors.invalidImageType": "所选文件不是有效图像。",
                "errors.invalidImageType.title": "文件无效",
                "errors.invalidImageType.message": "所选文件不是有效图像。",
                "errors.uploadFailed": "无法上传图像。再试一次。",
                "errors.uploadFailed.title": "上传错误",
                "errors.uploadFailed.message": "无法上传图像。再试一次。",
                "errors.conversationCreate": "创建对话时出错。请再试一次。",
                "errors.conversationInvalidId": "对话 ID 无效。",
                "errors.conversationOpen": "打开对话时出错。请再试一次。",
                "errors.favoriteUpdate": "收藏夹更新失败",
                "errors.blockUpdate": "无法更新锁",
                "errors.messageEdit": "编辑消息时出错。",
                "errors.foundation_sold_out": "创始人名额已售完。",
                "errors.unexpected_error": "发生意外错误。再试一次。",
                "errors.userInactive.title": "帐户已停用",
                "errors.tenantMismatch.title": "租户错误",
                'auth.tagline': '无论语言如何，都能被理解的力量',
                'auth.sign_in': '登录',
                'auth.create_account': '创建账户',
                'ui.search_contact': '搜索联系人...',
                'ui.language': '语言',
                'profile.my_profile': '我的资料',
                'profile.status': '状态',
                'profile.invite_email': '通过电子邮件邀请联系人',
                'profile.sent_invitations': '已发送的邀请',
                "profile.users": "用户",
                'profile.settings': '设置',
                'profile.appearance': '外观',
                'profile.logout': '退出',
                'contacts.mode': '模式',
                'contacts.sent': '已发送',
                'contacts.actions': '操作',
                'contacts.pending': '待处理',
                'contacts.available': '可用',
                'contacts.invited_registered': '已邀请 - 已注册',
                'table.email': '电子邮件',
                'table.language': '语言',
                'table.mode': '模式',
                'table.status': '状态',
                'table.sent': '已发送',
                'table.actions': '操作',
  'promotions.invite.message': '我邀请您使用 ArChat——用任何语言说话。我们双方都获益匪浅。',
  'promotions.progress.pending': '您有等待解锁奖励的邀请。',
  'promotions.progress.in_progress': '您的邀请正在进行中：真实对话后奖励激活。',
  'promotions.progress.remaining': '您还需要进行 {count} 次对话才能获得奖励。',
  'promotions.progress.sent_count': '发送',
  'promotions.progress.pending_count': '待办的',
  'promotions.progress.in_progress_count': '进行中',
  'promotions.progress.completed_count': '完全的',
  'promotions.banner.empty': '立即开始：邀请联系人并解锁福利。',
  'promotions.banner.pending': '您有待处理的邀请：完成真实对话并获得奖励。',
  'promotions.banner.reward': '您已经解锁了奖励！不断邀请来增加你的收获。',
  'promotions.cta.copy': '复制消息和链接',
  'promotions.cta.copied': '消息已复制',
  'promotions.cta.copy_error': '无法复制消息',

  'promotions.title': '促销和奖励',
  'promotions.subtitle': '邀请联系人并通过实际使用解锁福利。',
  'promotions.how_it_works': '它是如何运作的',
  'promotions.step1': '从您的个人资料中邀请联系人。',
  'promotions.step2': '当他们接受并进行真实互动聊天时，系统会自动进行验证。',
  'promotions.step3': '奖励已记入并更新您的进度。',
  'promotions.rewards.title': '奖励',
  'promotions.reward.invite': '每个经过验证的推荐都会获得奖励。',
  'promotions.reward.milestone': '成长里程碑的奖金。',
  'promotions.reward.ranking': '在顶级网络建设者排名中的知名度。',
  'promotions.progress.title': '你的进步',
  'promotions.progress.sent': '发送',
  'promotions.cta.invite': '邀请联系',
  'promotions.banner': '激活促销：邀请并通过实际使用获得奖励。',
  'promotions.modal.title': '促销计划',
  'promotions.modal.body': '每个经过验证的邀请可赚取 +10.000 个字符。\\n立即邀请即可解锁奖励。',
  'promotions.modal.cta': '查看促销活动',
                "app.install_ios_hint": "要安装：共享 > 添加到主屏幕",
                'menu.promotions': '促销',
                "suggestions.new": "新建议",
                "suggestions.empty": "您还没有提交任何建议。",
                "suggestions.admin_note": "团队笔记",
                "suggestions.status.pending": "耳环",
                "suggestions.status.reviewed": "修改",
                "suggestions.status.planned": "计划",
                "suggestions.status.implemented": "实施的",
                "suggestions.status.rejected": "被拒绝",
                "referral.promo": "邀请并赢得 10,000 个角色",
                "referral.stats.sent": "发送",
                "referral.stats.accepted": "公认",
                "referral.stats.rewards": "奖励",
                "referral.reward.pending": "耳环",
                "referral.reward.granted": "充满",
                "referral.reward.invalid": "无效的",
                "referral.reward.in_progress": "使用中",
                "referral.limit.reached": "奖励上限已达",
                "referral.waiting.usage": "当您和您的访客在同一次聊天中发送至少一条真实文本消息时，每条消息 +10,000 个字符（经过服务器验证）。",
                "common.avatar": "阿凡达",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "还没有留言",
                "messages.loading": "正在加载消息...",
                "messages.connecting_server": "正在连接消息服务器...",
                "messages.pending_send_count": "{count} 条消息等待传送",
                "presence.custom.suggestion.coffee": "有一些伙伴☕",
                "presence.custom.suggestion.soccer": "在球场上⚽",
                "presence.custom.suggestion.working": "疯狂地工作💪",
                "presence.custom.suggestion.lunch": "吃午饭了🍽️",
                "presence.custom.suggestion.family": "家庭午餐👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "学习中📚",
                "presence.custom.suggestion.travel": "旅行中✈️",
                "presence.custom.suggestion.meeting": "开会时💼",
                "presence.custom.suggestion.resting": "休息中😴",
                "presence.custom.suggestion.gaming": "玩电子游戏🎮",
                "presence.custom.suggestion.reading": "阅读📖",
                "presence.custom.suggestion.offlineSoon": "我马上回来⏳",
                "invitation.safe.phase_notice": "主动安全阶段：收益待商业激活（对限制没有实际影响）。",
                "invitation.safe.generate_code": "生成链接/代码",
                "invitation.safe.refresh_top3": "更新前 3 名",
                "invitation.safe.top_loading": "正在加载顶级邀请者...",
                "invitation.safe.top_empty": "还没有特色受邀者。",
                "invitation.safe.hide_full_ranking": "隐藏完整排名",
                "invitation.safe.view_full_ranking": "查看完整排名",
                "invitation.safe.hide_metrics_dashboard": "隐藏指标仪表板",
                "invitation.safe.view_metrics_dashboard": "查看指标仪表板",
                "invitation.safe.prepared_link": "链接已准备好",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "注册等待邀请",
                "invitation.safe.status_summary": "状态摘要",
                "invitation.safe.summary.pending": "耳环",
                "invitation.safe.summary.registered": "挂号的",
                "invitation.safe.summary.active": "积极的",
                "invitation.safe.summary.validated": "已验证",
                "invitation.safe.summary.rejected": "被拒绝",
                "invitation.safe.sent_invitations": "发出邀请函",
                "invitation.safe.table.id": "ID",
                "invitation.safe.table.invited_email": "访客电子邮件",
                "invitation.safe.table.code": "代码",
                "invitation.safe.table.status": "状态",
                "invitation.safe.table.created": "已创建",
                "invitation.safe.empty_sent": "尚未发出邀请。",
                "invitation.safe.simulated_rewards": "模拟获得的奖励",
                "invitation.safe.empty_rewards": "目前没有模拟奖励。",
                "invitation.safe.error.load_status": "无法加载邀请状态。",
                "invitation.safe.error.generate_code": "无法生成代码。",
                "invitation.safe.error.invalid_email": "输入有效的电子邮件以注册邀请。",
                "invitation.safe.error.register_pending": "无法注册待处理的邀请。",
                "invitation.safe.success.code_generated": "成功生成代码。",
                "invitation.safe.success.pending_registered": "在安全模式下注册的待处理邀请。",
                "invitation.status.deleted": "被淘汰",
                "invitation.deleted.tooltip": "该邀请已被删除",
                "invitation.status.rejected": "被拒绝",
                "invitation.status.bounced": "退回",
                "invitation.status.unknown": "状态未知",
                "dashboard.admin.title": "增长指标",
                "dashboard.admin.newUsersToday": "今天新用户",
                "dashboard.admin.messagesSentToday": "今天发送的消息",
                "dashboard.admin.translationsUsed": "使用的翻译",
                "dashboard.admin.invitesCreated": "已创建邀请",
                "dashboard.admin.invitesValidated": "已验证的邀请",
                "dashboard.admin.inviteConversion": "邀请转换",
                "dashboard.admin.kFactor": "K因子",
                "dashboard.admin.newUsers": "新用户",
                "dashboard.admin.messagesSent": "已发送消息",
                "dashboard.admin.noData": "无数据",
                "dashboard.admin.kFactor.viral": "病毒性的",
                "dashboard.admin.kFactor.stable": "稳定的",
                "dashboard.admin.kFactor.low": "低的",
                "dashboard.admin.emailMetrics": "电子邮件指标",
                "dashboard.admin.email.sent": "发送",
                "dashboard.admin.email.delivered": "发表",
                "dashboard.admin.email.opened": "打开",
                "dashboard.admin.email.clicked": "点击次数",
                "dashboard.admin.email.bounced": "退回",
                "dashboard.admin.email.deliveryRate": "交货率",
                "dashboard.admin.email.openRate": "打开率",
                "dashboard.admin.email.bounceRate": "跳出率",
                "dashboard.admin.funnelMetrics": "漏斗指标",
                "dashboard.admin.funnel.registered": "挂号的",
                "dashboard.admin.funnel.confirmed": "确认的",
                "dashboard.admin.funnel.loggedIn": "首次登录",
                "dashboard.admin.funnel.firstMessage": "第一条消息",
                "dashboard.admin.funnel.abandoned": "弃",
                "dashboard.admin.funnel.conversionRate": "转化率",
                "dashboard.admin.funnel.activationRate": "激活率",
                "dashboard.admin.funnel.dropoffRate": "辍学率",
                "dashboard.admin.loading": "正在加载指标...",
                "dashboard.admin.errorLoad": "无法加载指标仪表板。",
                "dashboard.admin.growthViral": "病毒式增长",
                "dashboard.admin.growthStable": "稳定增长",
                "dashboard.admin.growthLow": "低增长",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "代码",
                "errors.modal.message": "信息",
                "errors.modal.path": "路线",
                "errors.modal.time": "小时",
                "errors.modal.timestamp": "时间戳",
                "errors.modal.copied": "复制的详细信息",
                "errors.network": "无法连接到服务器。检查您的连接。",
                "errors.unexpected": "发生意外错误。再试一次。",
                "errors.boundary.title": "捕获反应错误",
                "errors.boundary.request_id": "X-请求-ID：",
                "errors.boundary.correlate": "映射到 backend/logs/structured.log",
                "errors.boundary.message_label": "信息：",
                "errors.boundary.stack_trace": "堆栈跟踪",
                "errors.boundary.component_stack": "组件堆栈",
                "errors.boundary.empty": "（空的）",
                "errors.boundary.reload_page": "重新加载页面",
                "errors.ui_boundary.refresh": "ArChat 界面错误 — 页面重新加载",
                "bootstrap.error.title": "ArChat® — 启动错误",
                "common.reload": "充值",
                "admin.access_denied.message": "信息",
                "admin.access_denied.title": "标题",
                "admin.action.change_plan": "改变计划",
                "admin.action.reactivate": "重新激活",
                "admin.action.suspend": "暂停",
                "admin.action.view": "看法",
                "admin.confirm.change_plan.message": "信息",
                "admin.confirm.change_plan.title": "标题",
                "admin.confirm.suspend.message": "信息",
                "admin.confirm.suspend.title": "标题",
                "admin.details.created": "已创建",
                "admin.details.current_plan": "目前计划",
                "admin.details.domain": "领域",
                "admin.details.last_activity": "上次活动",
                "admin.details.name": "薯",
                "admin.details.plan": "计划",
                "admin.details.status": "地位",
                "admin.details.subscription": "订阅",
                "admin.details.tenant_id": "租户ID",
                "admin.details.tenant_info": "租户信息",
                "admin.details.usage": "用法",
                "admin.error.change_plan": "改变计划",
                "admin.error.generic": "通用的",
                "admin.error.load_details": "加载详情",
                "admin.error.load_tenants": "加载租户",
                "admin.error.reactivate": "重新激活",
                "admin.error.suspend": "暂停",
                "admin.error.title": "标题",
                "admin.filter.active": "激活",
                "admin.filter.all_plans": "所有计划",
                "admin.filter.all_status": "所有状态",
                "admin.filter.suspended": "暂停",
                "admin.limit.devices": "设备",
                "admin.limit.invitations": "邀请函",
                "admin.limit.messages": "消息",
                "admin.limit.storage": "贮存",
                "admin.limit.users": "用户",
                "admin.loading": "加载中",
                "admin.no_tenants": "非租户",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "激活",
                "admin.status.suspended": "暂停",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "最后付款",
                "admin.subscription.status": "地位",
                "admin.subtitle": "字幕",
                "admin.success.plan_changed": "计划改变",
                "admin.success.tenant_reactivated": "租户重新启用",
                "admin.success.tenant_suspended": "租户被暂停",
                "admin.success.title": "标题",
                "admin.table.actions": "行动",
                "admin.table.messages": "消息",
                "admin.table.name": "薯",
                "admin.table.plan": "计划",
                "admin.table.status": "地位",
                "admin.table.storage": "贮存",
                "admin.table.tenant_id": "租户ID",
                "admin.table.users": "用户",
                "admin.title": "标题",
                "admin.usage.devices": "设备",
                "admin.usage.invitations": "邀请函",
                "admin.usage.messages": "消息",
                "admin.usage.storage": "贮存",
                "admin.usage.users": "用户",
                "auth.login": "登录",
                "auth.register": "登记",
                "auth.reset_password": "重置密码",
                "billing.cancel.button": "按钮",
                "billing.cancel.canceling": "取消",
                "billing.cancel.confirm": "确认",
                "billing.cancel.error": "错误",
                "billing.cancel.success": "成功",
                "billing.character_billing.characters_used": "使用的字符",
                "billing.character_billing.consumption_pct": "消费百分比",
                "billing.character_billing.days_remaining": "剩余天数",
                "billing.character_billing.deletion_date": "删除日期",
                "billing.character_billing.period_start": "经期开始",
                "billing.character_billing.renewal_date": "续订日期",
                "billing.character_billing.title": "标题",
                "billing.current_plan": "目前计划",
                "billing.founder_badge": "创始人徽章",
                "billing.no_plans": "不要计划",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "下次付款",
                "billing.subscription.plan": "计划",
                'billing.subscription.price': '方案价格',
                "billing.subscription.started": "开始",
                "billing.subscription.status": "地位",
                "billing.subscription.mp_flow.subscribe_failed": "无法开始订阅。再试一次。",
                "billing.subscription.mp_flow.change_plan_failed": "该计划无法更改。再试一次。",
                "billing.subscription.mp_status.pending": "耳环",
                "billing.subscription.mp_status.authorized": "授权",
                "billing.subscription.mp_status.active": "积极的",
                "billing.subscription.mp_status.paused": "已暂停",
                "billing.subscription.mp_status.cancelled": "取消",
                "billing.subscription.mp_status.inactive": "不活跃",
                "billing.subscription.mp_status.unknown": "一个陌生人",
                "billing.unlimited": "无限",
                "billing.update_plan": "更新计划",
                "billing.update_plan_modal.title": "标题",
                "billing.usage.loading": "加载中",
                "common.accept": "接受",
                "common.confirmPassword": "确认密码",
                'common.continue': '继续',
                "common.error": "错误",
                "dashboard.upgrade.to_plan": "计划",
                "emoji.noResults": "没有结果",
                "emoji.pick": "挑选",
                "export.restricted.message": "信息",
                "export.restricted.title": "标题",
                "export.restricted.upgrade": "升级",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "Q1",
                "help.faq.q2": "Q2",
                "help.faq.q3": "第三季度",
                "help.faq.q4": "第四季度",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "Q7",
                "help.faq.title": "标题",
                "help.howWorks.step4.point7": "第7点",
                "help.message_time_context.free_vs_pro": "免费与专业版",
                "help.message_time_context.point5": "要点5",
                "help.plans.enterprise.benefits": "好处",
                "help.plans.enterprise.description": "描述",
                "help.plans.enterprise.title": "标题",
                "help.plans.foundation.devices": "设备",
                "help.plans.free.description": "描述",
                "help.plans.free.devices": "设备",
                "help.plans.free.limits": "限制",
                "help.plans.free.title": "标题",
                "help.plans.intro": "简介",
                "help.plans.pro.benefits": "好处",
                "help.plans.pro.description": "描述",
                "help.plans.pro.devices": "设备",
                'help.plans.pro.price': '每月 $19',
                "help.plans.pro.title": "标题",
                "help.plans.pro.upgrade": "升级",
                "help.plans.title": "标题",
                "help.plans.urgent_slots_badge": "紧急插槽徽章",
                "help.slogan.final": "结尾",
                "help.suggestions.point1": "要点1",
                "help.suggestions.point2": "要点2",
                "help.suggestions.title": "标题",
                "invitation.already_contact_added": "已添加联系方式",
                "invitation.already_contact_title": "已联系标题",
                "invitation.already_pending": "已待处理",
                "invitation.language.invalid": "无效的",
                "message.send": "发送",
                "message.sendFile": "发送文件",
                "messages.conversations": "对话",
                "messages.no_conversations_subtitle": "没有对话字幕",
                "messages.no_conversations_title": "没有对话标题",
                "presence.custom.edit": "编辑",
                "profile.enrichment.country": "国家",
                "profile.enrichment.country.select": "选择",
                "profile.enrichment.description": "描述",
                "profile.enrichment.org_size": "组织规模",
                "profile.enrichment.org_size.placeholder": "占位符",
                "profile.enrichment.save": "节省",
                "profile.enrichment.skip": "跳过",
                "profile.enrichment.title": "标题",
                "profile.enrichment.usage_type.label": "标签",
                "profile.enrichment.usage_type.placeholder": "占位符",
                "profile.founderPosition": "创始人职位",
                "settings.confirmations.description": "描述",
                "settings.confirmations.disable": "禁用",
                "settings.confirmations.title": "标题",
                "settings.confirmations.updated": "已更新",
                "settings.title": "标题",
                "theme.description": "描述",
                "google.unavailable_tenant": "此租户无法使用 Google。",
                "google.unavailable": "谷歌不可用。",
                "google.verify_client_id": "在 Google Cloud Console 中验证客户端 ID。",
                'google.login_aria': '使用 Google 登录',
                "message.preview_alt": "预览",
                "message.image_attachment_alt": "附图",
                "profile.avatar.alt": "头像",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "正在加载顶级邀请者...",
                "invitation.top.empty": "尚无精选邀请者。",
                "invitation.contacts.title": "邀请联系人",
                "invitation.contacts.safe_phase_note": "安全阶段有效：待定的福利不会影响实际限制。",
                "invitation.contacts.generate_code": "生成代码/链接",
                "invitation.contacts.refresh_top3": "刷新前3名",
                "invitation.contacts.hide_full_ranking": "隐藏完整排名",
                "invitation.contacts.show_full_ranking": "显示完整排名",
                "invitation.contacts.hide_metrics_dashboard": "隐藏指标仪表板",
                "invitation.contacts.show_metrics_dashboard": "显示指标仪表板",
                "invitation.contacts.prepared_link_label": "准备好的链接：",
                "invitation.contacts.email_placeholder": "电子邮件@domain.com",
                "invitation.contacts.register_pending": "注册等待邀请",
                "invitation.contacts.status_summary": "状态总结",
                "invitation.contacts.sent_invitations": "已发送邀请",
                "invitation.contacts.invited_email": "邀请邮件",
                "invitation.contacts.code": "代码",
                "invitation.contacts.no_sent_invitations": "我还没有发出邀请。",
                "invitation.contacts.simulated_rewards": "模拟获得的奖励",
                "invitation.contacts.no_simulated_rewards": "还没有模拟奖励。",
                "common.id": "ID",
                "common.created": "已创建",
                'plan.pro_contacts': '每位用户最多 100 个联系人',
                "common.status": "地位",
                "login.prompt_create_account_with_name": "您想用这个名字创建一个帐户吗？",
                'plans.upgrade.title': '升级计划',
                'plans.upgrade.comparison': '计划对比',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': '可随时取消',
                'plans.actions.upgrade_pro': '升级到 PRO',
                'plans.actions.become_founder': '成为 Founder',

                'plans.modal.card.current_badge': '您当前的套餐',

                'plans.modal.card.lower_tier': '低于您当前生效的套餐',

                'plans.modal.card.manage_in_profile': '要更改或取消：请在个人资料中的订阅与账单操作。',
                'plans.modal.card.cancel_subscription': '取消订阅',
                'plans.modal.cancel_confirm.title': '取消或管理订阅',
                'plans.modal.cancel_confirm.body': '将在新标签页打开安全的 Paddle 门户，用于更新付款方式、查看发票或取消订阅。',
                'plans.modal.cancel_confirm.continue_button': '继续',
                'plans.modal.cancel_confirm.back_button': '返回',
                'plans.modal.cancel_paddle_fallback.title': '管理订阅',
                'plans.modal.cancel_paddle_fallback.body': '当前环境不会打开 Paddle 计费门户（例如本地开发或尚未关联）。您仍可在此查看和比较方案。',
                'plans.modal.cancel_paddle_fallback.confirm': '知道了',
                'plans.upgrade_required': 'PRO 套餐可用',
                'settings.heading': '设置',
                'settings.dashboard': '总览',
                'settings.dashboardDescription': '本地首页面板与可见区块的偏好设置。',
                'settings.dashboardGridHeading': '面板区块',
                'settings.dashboardShowOnStartDescription': '开启后，登录时打开总览而不是联系人列表。',
                'settings.dashboardBlockWelcome': '欢迎',
                'settings.dashboardBlockUsage': '套餐用量',
                'settings.dashboardBlockFiles': '我的文件',
                'settings.dashboardBlockPromotions': '活动',
                'settings.dashboardBlockSessions': '会话',
                'settings.dashboardWelcomeDescription': '新手引导、邀请联系人与帮助入口。',
                'settings.dashboardUsageDescription': '与限额对比的用量：联系人、字符、存储、设备。',
                'settings.dashboardFilesDescription': '“我的文件”中可见文件与空间摘要。',
                'settings.dashboardPromotionsDescription': '活动摘要与项目链接。',
                'settings.dashboardSessionsDescription': '活动会话与设备；如可用可结束其他会话。',
                'settings.enabled': '开',
                'settings.disabled': '关',
                'settings.showDashboardOnStart': '登录后显示总览',
                'settings.showWelcomeBlock': '显示欢迎区',
                'settings.showPromotionsBlock': '显示推广区',
                'settings.showUsageBlock': '显示套餐用量',
                'settings.showRecentConversationsBlock': '显示最近会话（每位联系人最后一条消息）',
                'settings.showSessionsBlock': '显示活动会话',
                'settings.showFilesBlock': '显示我的文件摘要',
                'settings.dashboardLocalNote': '首选项暂存在本浏览器，直至提供个人资料 API。',
                'settings.appearanceSettings': '外观',
                'settings.argentinaTheme': '阿根廷主题',
                'settings.darkMode': '深色模式',
                'settings.language': '语言',
                'settings.messageSound': '消息提示音',
                'settings.playSoundDescription': '为新消息或重要提醒播放声音。',
                'settings.messageSoundEnabled': '开',
                'settings.messageSoundDisabled': '关',
                'settings.accountSettings': '账户',
                'settings.deleteAccount': '删除账户',
                'settings.deleteAccountWarning': '此操作是永久性的。您的数据、消息、联系人和设置将按照平台的删除流程被移除。',
                'settings.deleteMyAccount': '删除我的账户',
                'dashboard.contacts': '联系人',
                'dashboard.characters': '字符',
                'dashboard.storage': '存储',
                'dashboard.active_devices': '活跃设备',
                'dashboard.need_more_resources': '需要更多资源吗？',
                'dashboard.upgrade_message': '升级你的套餐以获得更多联系人、字符、存储和活跃设备。',
                'dashboard.upgrade_button': '升级到 PRO',
                'dashboard.upgrade_button_pro': '升级到 PRO',
                'dashboard.upgrade_button_foundation': '升级到 FOUNDATION',
                'files.preview': '预览',
                'files.previewFile': '文件预览',
                'files.previewUnavailable': '无法预览。',
                'files.previewLoading': '正在加载预览…',
                'files.openPreview': '预览',
                'files.downloadFile': '下载文件',
                'files.downloadFailed': '无法下载文件。请检查网络连接和登录状态后重试。',
                'files.closePreview': '关闭预览',
                'files.unsupportedPreview': '此文件类型无预览。可查看信息或下载文件。',
                'files.pdfPreviewHelp': '浏览器可能无法内嵌显示 PDF。请下载后打开。',
                'files.labelFileType': '类型',
                'files.previewForbidden': '无预览权限。',
                'files.previewNotFound': '文件不可用或已在账户中不可见。',
                'files.unavailableForFree': '“我的文件”不包含在 FREE 方案中。',
                'files.availableInFoundationAndPro': '“我的文件”可在 FOUNDATION 与 PRO 方案中使用。',
                'files.filesFeatureRestricted': '您当前的方案无法使用此功能。',
                'files.filesLoadError': '加载文件时出错。',
                'files.uploadUnavailableForFree': '免费版无法发送文件。',
                'files.uploadAvailableInFoundationAndPro': '在 FOUNDATION 和 PRO 中可发送文件。',
                'files.recipientStorageFull': '对方没有足够空间接收此文件。',
                'files.recipientNoAvailableStorage': '对方没有足够空间接收此文件。',
                'files.storageQuotaExceeded': '您已达到当前套餐的存储上限。',
                'files.freeStorageLimit': '免费版含 5 MB 用于接收文件。',
                'settings.unreadEmailReminderSection': '未读邮件摘要',
                'settings.unreadEmailReminderDescription': '若新消息或文件未读时间超过下方设置，ArChat 会发送一封汇总邮件（不会每封消息单独发信）。',
                'settings.unreadEmailReminderToggle': '通过邮件接收未读摘要',
                'settings.unreadEmailDelayHours': '发送前等待（小时）',
                'settings.unreadEmailDelayHint': '1–168 小时（最长一周）。邮件语言与资料语言一致。',
                'subjects.title': '主题',
                'subjects.singular': '主题',
                'subjects.plural': '主题',
                'subjects.general': '常规',
                'subjects.new': '新建主题',
                'subjects.create': '创建主题',
                'subjects.rename': '重命名',
                'subjects.finish': '结束',
                'subjects.reopen': '重新打开',
                'subjects.select': '继续',
                'subjects.status.open': '开放',
                'subjects.status.pending': '待定',
                'subjects.status.finished': '已完成',
                'subjects.limitReached': '此对话的活跃主题已达上限。请先结束一个主题再新建。',
                'subjects.limitReachedFree': 'FREE 方案：每个对话最多 3 个活跃主题。请先结束一个主题再新建。',
                'subjects.limitReachedPro': 'PRO 方案：每个对话最多 5 个活跃主题。请先结束一个主题再新建。',
                'subjects.limitReachedFoundation': 'FOUNDATION 方案：每个对话最多 5 个活跃主题。请先结束一个主题再新建。',
                'subjects.activeLimitsLine': '活跃主题：{current} / {max}',
                'subjects.closedListTitle': '已关闭的主题',
                'subjects.viewClosed': '查看已关闭的主题',
                'subjects.noClosedSubjects': '没有已关闭的主题。',
                'subjects.reopenSubject': '重新打开',
                'subjects.reopenedSubjects': '重新打开的主题',
                'subjects.reopenLimitReached': '您已达到活跃主题上限。请先结束另一个主题以重新打开此主题。',
                'subjects.ownerOnlyReopen': '只有创建该主题的用户才能重新打开。',
                'subjects.modal.title': '对话主题',
                'subjects.modal.subtitle': '选择或管理此对话的主题。',
                'subjects.contactLabel': '联系人：',
                'subjects.ownerOnlyRename': '只有创建该主题的用户才能重命名。',
                'subjects.ownerOnlyStateChange': '只有创建该主题的用户才能更改状态。',
                'subjects.createdByOther': '该主题由对方创建。您可以回复，但不能更改名称。',
                'subjects.empty': '没有可显示的主题。',
                'subjects.noResults': '未找到主题。',
                'subjects.error.generic': '无法完成操作。请重试。',
                'subjects.error.featureDisabled': '此环境不提供主题功能。',
                'subjects.error.duplicateName': '已存在同名的活动主题。',
                'subjects.error.ownerRequired': '您无权修改此主题。',
                'subjects.error.defaultCannotRename': '无法重命名“常规”主题。',
                'subjects.error.defaultCannotFinish': '无法结束“常规”主题。',
                'subjects.current': '主题',
                'subjects.change': '更改主题',
                'subjects.currentLabel': '主题：',
                'subjects.changeSubject': '更改主题',
                'subjects.closedCannotSend': '该主题已结束。请重新打开以发送新消息。',
                'subjects.selectBeforeSend': '在弹窗中选择主题以查看和发送消息。',
                'subjects.loadingMessages': '正在加载该主题的消息…',
                'subjects.messageFilterError': '无法加载该主题的消息。',

                // Tags
                "tags.etiquetas": "标签",
                "tags.manageTitle": "管理标签",
                "tags.manage": "🏷️标签",
                "tags.allTags": "所有标签",
                "tags.confirmDelete": "删除这个标签吗？",
                "tags.tagNamePlaceholder": "标签名称",
                "tags.create": "创造",
                "tags.noTags": "没有标签。在上面创建一个。",
                "tags.save": "节省",
                "tags.edit": "编辑",
                "tags.delete": "删除",
                "tags.assignTo": "分配给",
                "tags.noTagsToAssign": "没有可用的标签。首先创建它们。",
                // Templates
                "templates.selectTitle": "模板",
                "templates.noTemplates": "没有模板。在上面创建一个。",
                "templates.manage": "管理模板",
                "templates.confirmDelete": "删除这个模板吗？",
                "templates.manageTitle": "管理模板",
                "templates.titlePlaceholder": "模板标题",
                "templates.bodyPlaceholder": "编写模板消息...",
                "templates.create": "创建模板",
                "templates.save": "节省",
                "templates.edit": "编辑",
                "templates.delete": "删除",
                // Tags (added)
                "tags.bgColor": "背景颜色",
                "tags.textColor": "文字颜色",
                "tags.selectTag": "选择一个标签",
                // Web Push notifications
                "settings.webPushSection": "系统通知（Web 推送/PWA）",
                "settings.webPushDescription": "当应用程序在后台运行或在移动设备上关闭时允许发出警报。需要构建中的 VAPID 公钥 (VITE_VAPID_PUBLIC_KEY) 和服务器密钥。授予浏览器权限并注册该设备。",
                "settings.webPushButton": "启用推送通知",
                "settings.webPushRegistering": "注册…",
                "settings.webPushState.granted": "已获得许可。如果配置了 VAPID，订阅将发送到服务器。",
                "settings.webPushState.denied": "没有权限。在浏览器设置中启用此站点的通知。",
                "settings.webPushState.default": "点击按钮请求许可并注册该设备。",
                "settings.webPushState.unsupported": "此浏览器不支持 Web Push。",
                "settings.webPushVapidMissing": "此前端构建中缺少 VITE_VAPID_PUBLIC_KEY：推送订阅无法完成。",
                ...PRESET_LOCALES.zh,
                "auth.login.clear_password_lock_after_reset": "我已经更改了密码（例如在另一台设备上）",
                "auth.signup_disabled": "在此环境中暂时禁用新帐户注册。",
                "auth.reset_user_not_found": "我们没有找到与该电子邮件关联的帐户。检查拼写是否正确或创建一个新帐户。",
                "account.not_found": "未找到帐户。",
                "auth.pending_activation.title": "帐户待激活",
                "auth.pending_activation.body": "您的帐户尚未激活。检查您的电子邮件并确认您注册进入 ArChat。",
                "auth.pending_activation.back_to_login": "返回登录",
                "auth.pending_activation.support_prefix": "您需要帮助吗？联系支持：",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "用于重新发送激活的电子邮件",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "输入您注册时使用的电子邮件以重新发送激活。",
                "auth.pending_activation.sent_title": "激活邮件已发送",
                "auth.pending_activation.sent_body": "如果该电子邮件对应于待处理的帐户，我们将向您发送新的激活链接。检查您的收件箱以及垃圾邮件。",
                "auth.pending_activation.soft_error_title": "无法重新发送",
                "auth.pending_activation.soft_error_body": "我们目前无法处理重新发送。几分钟后重试或写信给我们：info@archat.com.ar。",
                "auth.pending_activation.resend_again": "重新发送",
                "menu.plans": "计划",
                "files.title": "我的文件",
                "files.filter_all": "全部",
                "files.filter_sent": "发送",
                "files.filter_received": "已收到",
                "files.filter_images": "图片",
                "files.filter_documents": "文件",
                "files.col_name": "姓名",
                "files.col_size": "尺寸",
                "files.col_date": "日期",
                "files.col_direction": "导演。",
                "files.col_actions": "行动",
                "files.sent": "📤 已发送",
                "files.received": "📥 已收到",
                "files.download": "释放",
                "files.delete_for_me": "为我删除",
                "files.delete_confirm_title": "删除文件",
                "files.delete_confirm_message": "该文件将从您的帐户中删除。不会为其他人删除。继续？",
                "files.empty": "你没有文件。",
                "files.error_loading": "上传文件时出错。",
                "files.load_more": "加载更多",
                "message.status.sending": "正在发送...",
                "message.status.failed": "未发送",
                "message.status.sent": "发送",
                "message.status.delivered": "发表",
                "message.status.read": "读",
                "home.public_nav.pricing": "价格",
                "home.public_nav.aria": "主站导航",
                "home.public_footer.aria": "法律链接",
                "home.pricing_link": "计划和价格",
                "publicPricing.nav.back_home": "← 首页",
                "publicPricing.title": "计划和价格",
                "publicPricing.subtitle": "对 ArChat 订阅引擎的透明且一致的限制。国际结帐的美元商业价格（例如 Paddle）。",
                "publicPricing.commercial_note": "功能边界来自PlanConstants/PlanResolver；您的帐户可以在数据库中应用 plan_limits。商户收费使用Paddle（或ArChat官方指定的其他处理器），美元定价如下。",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "与 PRO（高级合同）相同的技术限制。",
                "publicPricing.same_limits_foundation": "与 FOUNDATION（高级合约）相同的技术限制。",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "每个帐户每月 30,000 个字符。",
                "publicPricing.free.b2": "每个用户最多 2 个联系人；每个帐户最多 2 个活跃对话。",
                "publicPricing.free.b3": "无附件或存储空间；无需数据导出。",
                "publicPricing.free.b4": "消息历史记录长达30天；每个用户 1 台设备。",
                "publicPricing.free.b5": "每天 34 条消息，每月 1,000 条消息（租户）；每天最多 20 个邀请。",
                "publicPricing.premium.b1": "每个帐户每月 300,000 个字符；每个用户最多 100 个联系人。",
                "publicPricing.premium.b2": "无限对话和聊天（租户）；每天 1,667 条消息，每月 50,000 条消息。",
                "publicPricing.premium.b3": "高达 50 MB 的存储空间（租户）；每个用户最多 3 台设备。",
                "publicPricing.premium.b4": "无限邀请（租户）；按计划导出、自动翻译和文件。",
                "publicPricing.premium.b5": "FOUNDATION：与 PRO 相同的技术合同，加上创始人计划（150 个名额）。 PRO：高级标准。",
                "publicPricing.foundation.founder_note": "方正商业计划：{slots}名额数量有限（参见计划摘要）。订阅激活后，PRO 限制相同。",
                "publicPricing.cta.start_free": "创建免费帐户",
                "publicPricing.cta.register_paid": "创建账户",
                "publicPricing.paddle_hint": "启用充电后，将在应用程序内完成对所选处理器的检查。",
                "publicPricing.legal.nav_label": "合法的",
                "publicPricing.legal.terms": "服务条款",
                "publicPricing.legal.privacy": "隐私政策",
                "publicPricing.legal.refund": "退款政策",
                "profile.security.privacy_note": "管理您帐户的隐私和安全。",
                "profile.security.sessions_title": "活跃会话",
                "profile.security.current": "当前会话",
                "profile.plan.foundation.description": "FOUNDATION 计划（创始人）：与 PRO 相同的高级使用，具有创始人计划和有限的空间（150 个座位）。",
                "billing.view_plans": "查看计划",
                "billing.paddle.cancel_via_portal": "取消订阅",
                "billing.paddle.test_access_denied_body": "在此服务器上，计费操作受到限制（测试模式或测试列表）。如果您已经使用真实账户付款，则在生产中必须允许所有用户付款（例如 PAYMENTS_ALLOW_ALL_BILLING_USERS），或者必须禁用该限制。联系支持人员。",
                "attachment.storage_insufficient_precheck.title": "空间不足",
                "attachment.storage_insufficient_precheck.message": "该文件的大小为 {fileSizeMb} MB，而您只有 {availableMb} MB 可用。释放空间或改进您的计划以继续。",
                "attachment.files_disabled.title": "计划限额",
                "attachment.files_disabled.message": "您当前的计划不包括文件发送。改进你的计划以继续。",
                "contacts.viewContactInfo": "查看联系方式",
                "contacts.contactInfoTitle": "联系方式",
                "contacts.phone": "电话",
                "contacts.bio": "传",
                "contacts.notProvided": "不知情",
                "contacts.unread.badge": "未读消息",
                "dashboard.recentInbound.title": "最后收到的消息",
                "dashboard.recentInbound.empty": "您最近没有收到消息。",
                "dashboard.recentInbound.error": "无法加载消息。",
                "dashboard.recentInbound.previewPhoto": "照片",
                "dashboard.recentInbound.previewFile": "档案",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "消息不可用",
                "dashboard.recentInbound.readTitle": "读",
                "dashboard.recentInbound.unreadTitle": "未读",
                "dashboard.recentConversations.title": "最近的对话",
                "dashboard.recentConversations.empty": "没有对话可显示。",
                "dashboard.recentConversations.error": "无法加载对话。",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "无法提供翻译",
                "plan.errors.translationNotAllowed.message": "您当前的计划不包括语言之间的自动翻译。",
                "plan.errors.translationNotAllowed.solution": "要使用自动翻译，请升级您的计划。",
                "billing.subscription.cancel_scheduled_date": "您的订阅计划于 {{date}} 取消。在此之前您可以继续使用您的计划。",
                "billing.subscription.cancel_scheduled_badge": "于 {{date}} 取消",
                "billing.scheduled.plan_after_cancel_label": "期末计划：",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "更改为基金会",
                "billing.scheduled.switch_to_free": "更改为免费",
                "billing.scheduled.foundation_full_title": "基金会不可用",
                "billing.scheduled.foundation_full_message": "目前没有可用的 FOUNDATION 名额。在此期间结束时，您的计划将变为免费。",
                "billing.scheduled.saving": "保存...",
                "billing.scheduled.error_title": "更改计划时出错",
                "billing.scheduled.error_generic": "既定计划无法更改。再试一次。",
                "billing.cancel_scheduled.title": "预定取消",
                "billing.cancel_scheduled.desc": "您的订阅将于 {{date}} 取消。在此之前您可以继续使用当前的计划。",
                "billing.cancel_scheduled.no_new_plan_until_end": "在此订阅到期之前，您将无法签订其他计划。",
                "billing.cancel_scheduled.free_fallback": "如果您不续订任何计划，您的帐户将继续免费，但有相应的限制。",
                "billing.cancel_scheduled.profile_deactivation_hint": "您还可以通过您的个人资料取消订阅该平台。",
                "billing.cancel_scheduled.default_free": "期限结束时：免费",
                "google.missing_client_id": "Google Sign-in 在此版本中不可用：缺少 VITE_GOOGLE_CLIENT_ID（或 __ARCHAT_TENANT_CONFIG__ 中每个租户的 googleClientId）。",
                "reviews.title": "ArChat 评论",
                "reviews.create_title": "您如何评价 ArChat？",
                "reviews.edit_title": "编辑我的评论",
                "reviews.comment_placeholder": "告诉我们您的经历（可选）...",
                "reviews.submit_btn": "提交评论",
                "reviews.update_btn": "更新",
                "reviews.thank_you": "感谢您的评论！",
                "reviews.submitted_message": "您的意见有助于我们改进。",
                "reviews.error_select_rating": "选择评级",
                "reviews.error_generic": "提交评论时出错",
                "reviews.prompt_message": "你喜欢ArChat吗？留下您的评论！",
                "reviews.rate_now": "取得资格",
                "reviews.later": "之后",
                "reviews.write_review": "撰写评论",
                "reviews.edit_my_review": "编辑我的评论",
                "reviews.no_reviews": "还没有评论。成为第一！",
                "reviews.review_singular": "审查",
                "reviews.review_plural": "评论",
                "reviews.verified": "已验证",
                "reviews.anonymous": "匿名的",
                "files.storageUsed": "已用空间",
                "files.planQuota": "计划配额",
                "files.availableStorage": "可用的",
                "files.usagePercent": "用过的",
                "files.unlimited": "无限",
                "files.sentBy": "发送者",
                "files.unknownUser": "用户",
};

